
jQuery.reel || (function( $, window, document, undefined ){

	$.reel = {
		version: '1.1.3',

		// Options defaults
		def: {
			footage: 6, // number of frames per line/column
			frame: 1, // initial frame
			frames: 36, // total number of frames; every 10° for full rotation
			hint: '', // mouse-sensitive area hint tooltip
			horizontal: true, // roll flow; defaults to horizontal
			hotspot: undefined, // [deprecated] use `area` instead
			indicator: 0, // size of a visual indicator of reeling (in pixels)
			klass: '', // plugin instance class name
			loops: true, // is it a loop?
			reversed: undefined, // [deprecated] use `cw` instead
			spacing: 0, // space between frames on reel
			stitched: 0, // pixel width (length) of a stitched (rectilinear) panoramic reel
			suffix: '-reel', // sprite filename suffix (A.jpg's sprite is A-reel.jpg by default)
			tooltip: '', // [deprecated] use `hint` instead

			// [NEW] in version 1.1
			area: undefined, // custom mouse-sensitive area jQuery collection
			brake: 0.5, // brake force of the inertial rotation
			clickfree: false, // binds to mouse leave/enter events instead of down/up
			cw: false, // true for clockwise organization of sprite
			delay: -1, // delay before autoplay in seconds (no autoplay by default (-1))
			directional: false, // two sets of frames (for forward and backward motion) are used when true
			draggable: true, // mouse or finger drag interaction (allowed by default)
			entry: undefined, // speed of the opening animation (Hz, defaults to value of `speed`)
			graph: undefined, // custom graph function
			image: undefined, // image sprite to be used
			images: [], // sequence array of individual images to be used instead of sprite
			inversed: false, // flags inversed organization of frames in orbital object movie
			laziness: 6, // on "lazy" devices tempo is divided by this divisor for better performace
			monitor: undefined, // stored value name to monitor in the upper left corner of the viewport
			opening: 0, // duration of opening animation (in seconds)
			orbital: 0, // view centering tolerance in frames for dual-orbit object movies
			path: '', // URL path to be prepended to `image` or `images` filenames
			preloader: 2, // size (height) of a image loading indicator (in pixels)
			rebound: 0.5, // time spent on the edge (in seconds) of a non-looping panorama before it bounces back
			revolution: undefined, // distance mouse must be dragged for full revolution
			// (defaults to double the viewport size or half the `stitched` option)
			row: 1, // initial row
			rows: 0, // number of rows for a multi-row setup (zero from one-row setup)
			speed: 0, // animated rotation speed in revolutions per second (Hz)
			step: undefined, // initial step (overrides `frame`)
			steps: undefined, // number of steps a revolution is divided in (by default equal to `frames`)
			tempo: 36, // shared ticker tempo in ticks per second
			timeout: 2, // idle timeout in seconds
			throwable: true, // drag & throw interaction (allowed by default)
			vertical: false, // switches orbital object movie to vertical mode
			wheelable: true, // mouse wheel interaction (allowed by default)
			slidable: true,

            _wrapper: null,
			// ---
			// ### Annotations ######
			//
			// To further visually describe your scene you can place all kinds of in-picture HTML annotations
			// by defining an `annotations` object. Learn more about [Annotations][1] in a dedicated article.
			//
			// [1]:https://github.com/pisi/Reel/wiki/Annotations
			//

			// #### `annotations` Option ####
			// [NEW] `Object`, since 1.2
			annotations: undefined

		}
		// [deprecated] options defaults may be gone anytime soon
	}

	$.fn.reel = function( options, viewer360 ){

		this.viewer360 = viewer360;

		var opt = $.extend({}, $.reel.def, options),
			applicable = (function( tags ){
				// Only IMG tags with non-empty SRC and non-zero WIDTH and HEIGHT will pass

				var
					pass = []

				tags.filter(_img_).each(function( ix ){
					var $this = $(this),
						src = opt.images.length && opt.images || opt.image || $this.attr(_src_),
						width = number($this.css(_width_)),
						height = number($this.css(_height_))

					if( !src || src == __ || !width || !height ){
						return;
					}
					pass.push($this);
				});
				tags.filter(_div_ + dot(klass)).each(function( ix ){
					pass.push($(this));
				});

				return $(pass);
			})(this),
			instances = []
		// Backward-compatibility of [deprecated] legacy options

		opt.reversed && (opt.cw = true);
		opt.tooltip && (opt.hint = opt.tooltip);
		opt.hotspot && (opt.area = opt.hotspot);

		applicable.each(function(){
			var t = $(this),
				data = t.data(),

				// data storage
				set = function( name, value ){
					data[name] = value;
					t.trigger('store', [name, value]);
					return value;
				},
				get = function( name ){
					var value = data[name];
					t.trigger('recall', [name, value]);
					return value;
				},

				// Events & handlers
				on = {
					setup: function( e ){
						// - fills up the data storage with values based on options
						// - binds to ticker

						if( t.hasClass(klass) ){
							return cleanup.call(e);
						}

						var src = t.attr(_src_),
							id = set(_id_, t.attr(_id_) || t.attr(_id_, klass + '-' + (+new Date())).attr(_id_)),
							styles = t.attr('style'),
							images = opt.images,
							stitched = opt.stitched,
							loops = opt.loops,
							size = { x: number(t.css(_width_)), y: number(t.css(_height_)) },
							frames = set(_frames_, opt.orbital && opt.footage || opt.rows <= 1 && images.length
								|| opt.frames),
							rows = stitched ? 1 : ceil(frames / opt.footage),
							style = {
								//  display: 'block',
								width: size.x,
								height: size.y
							},
							stage_id = '#' + id + opt.suffix,
							classes = t.attr('class'),
							overlay_css = { position: 'relative', width: size.x, height: size.y },
							$overlay = $(_div_tag_, { id: stage_id.substr(1), 'class': classes + ___
								+ overlay_klass, css: overlay_css }),
							$instance = t.wrap($overlay).attr({ 'class': klass }).css(style).bind(on),
							instances_count = instances.push(add_instance($instance)[0])
						set(_image_, images.length && images.length || opt.image
							|| src.replace(/^(.*)\.(jpg|jpeg|png|gif)$/, '$1' + opt.suffix + '.$2'));
						set(_classes_, classes);
						set(_frame_, opt.frame);
						set(_spacing_, opt.spacing);
						set(_dimensions_, size);
						set(_fraction_, 0);
						set(_steps_, opt.steps || opt.frames);
						set(_revolution_, opt.revolution || stitched / 2 || size.x * 2);
						set(_rows_, rows);
						set(_bit_, 1 / (frames - (loops && !stitched ? 0 : 1)));
						set(_wheel_step_, 1 / max(frames, get(_steps_)));
						set(_stitched_, stitched);
						set(_stitched_travel_, stitched - (loops ? 0 : size.x));
						set(_stage_, stage_id);
						set(_backwards_, set(_speed_, opt.speed) < 0);
						set(_velocity_, 0);
						set(_vertical_, opt.vertical);
						set(_row_, (opt.row - 1) / (opt.rows - 1));
						set(_cwish_, negative_when(1, !opt.cw && !stitched));
						set(_reeling_, false);
						set(_brake_, opt.brake);
						set(_center_, !!opt.orbital);
						set(_tempo_, opt.tempo / ($.reel.lazy ? opt.laziness : 1));
						set(_opening_ticks_, 0);
						set(_annotations_, opt.annotations || $overlay.unbind(dot(_annotations_)) && {});
						set(_backup_, {
							src: src,
							style: styles || __
						});
						pool.bind(_tick_, on.tick);
						cleanup.call(e);
						t.trigger('setup.annotations');
						t.trigger('start');
					},

					teardown: function( e ){
						/*
						 - unbinds events, erases all state data
						 - reconstructs the original DOM element
						 */
						// get rid of Reel's own events
						t.unbind(ns).unbind(on);
						var
							events = t.data('events'),
						// clone & restore the original
							$original = t.clone()
								.attr(t.data(_backup_))
								.css({ background: 'transparent' })
								.removeClass(klass).addClass(get(_classes_));
						// clone original events (inspired by Brandon Aaron's copyEvents plugin)
						for( var type in events ){
							$.each(events[type], function( ix, handler ){
								// for this we need the 1.4.2+ version
								$original.bind(type + '.' + handler.namespace, handler.handler, handler.data);
							});
						}
						$('img:' + _hidden_, t.parent()).remove();
						remove_instance(t);
						// replace stage with the original
						$(get(_stage_)).before($original).detach();
						no_bias();
						pool
							.unbind(_tick_, on.tick)
							.unbind(_tick_, on.opening_tick);
						stage_pool
							.unbind(_mouseup_).unbind(_mousemove_);
						cleanup.call(e);
					},
					start: function( e ){
						/*
						 - binds all mouse/touch events (namespaced)
						 - prepares stage overlay elements
						 - preloads images if needed
						 */

						var
							space = get(_dimensions_),
							frames = get(_frames_),
							resolution = max(frames, get(_steps_)),
							fraction = set(_fraction_, 1 / resolution * ((opt.step || opt.frame) - 1)),
							frame = set(_frame_, fraction * frames + 1),
							loaded = 0,
							id = t.attr('id'),
							$overlay = t.parent(),
							$hi = $(_div_tag_, { 'class': hi_klass,
								css: { position: _absolute_, left: 0, top: 0, width: space.x, height: space.y, background: _hex_black_, opacity: 0 }
							}).appendTo($overlay),
							area = set(_area_, $(opt._wrapper || opt.area || $hi))
						if( $.reel.touchy ){

							// workaround for downsizing-sprites-bug-in-iPhoneOS inspired by Katrin Ackermann
							t.css({ WebkitUserSelect: 'none', WebkitBackgroundSize: opt.images.length
								? 'auto'
								: (get(_stitched_) && get(_stitched_) + 'px ' + space.y + 'px')
								|| (space.x * opt.footage) + 'px ' + (space.y * get(_rows_) * (opt.rows || 1)
								* (opt.directional ? 2 : 1)) + 'px'
							});
							area
								.bind(_touchstart_, function( e ){
									t.trigger('down', [finger(e).clientX, finger(e).clientY, true]);
								})
								.bind(_touchmove_, function( e ){
									t.trigger('slide', [finger(e).clientX, finger(e).clientY, true]);
									return !(opt.rows > 1 || opt.orbital || get(_reeling_))
								})
								.bind(_touchend_, function( e ){
									t.trigger('up', [true]);
									return false
								})
								.bind(_touchcancel_, function( e ){
									t.trigger('up', [true]);
									return false
								})
						}
						else{
							area
								//.css({ cursor: 'url('+drag_cursor+'), '+failsafe_cursor })
								.bind(_mousewheel_, function( e, delta ){
									t.trigger('wheel', [delta]);
									return false
								})
								.bind(_dblclick_, function( e ){
									t.trigger('play')
								})
								.bind(opt.clickfree ? _mouseenter_ : _mousedown_, function( e ){
									t.trigger('down', [e.clientX, e.clientY]);
									return false
								})
								.bind(opt.clickfree ? _mouseleave_ : '', function( e ){
									t.trigger('up');
									return false
								})
								.disableTextSelect();
						}
						(opt.hint) && area.attr(_title_, opt.hint);
						opt.monitor && $overlay.append($monitor = $(_div_tag_, {
							'class': monitor_klass,
							css: { position: _absolute_, left: 0, top: 0 }
						})) || ($monitor = $());
						opt.indicator && $overlay.append(indicator('x'));
						opt.rows > 1 && opt.indicator && $overlay.append(indicator('y'));
						t.trigger('preload');

					},

					preload: function( e ){
						/*
						 - preloads all frames and sprites
						 */
						var
							space = get(_dimensions_),
							$overlay = t.parent(),
							image = get(_image_),
							images = opt.images,
							preload = !images.length ? [image] : new Array().concat(images),
							img_tag = t[0],
							img_frames = img_tag.frames = preload.length,
							img_preloaded = img_tag.preloaded = 0
						t.trigger('stop');
						$overlay.append($preloader = $(_div_tag_, { 'class': preloader_klass,
							css: {
								position: _absolute_,
								left: 20,
								top: space.y - opt.preloader - 15,
								height: opt.preloader,
								overflow: _hidden_,
								backgroundColor: _hex_grey_
							}
						}));

						/* $overlay.append($icon360= $(_div_tag_, { 'class': 'jquery-reel-360',
						 css: {
						 position: _absolute_,
						 top: space.y - 80
						 }
						 }));



						 $icon360.hide()
						 */
						while( preload.length ){
							var uri = opt.path + preload.shift(),
								$img = $(new Image()).hide().bind('load' + ns, function update_preloader(){

									img_tag.preloaded++
									$(this).unbind(ns);
									$preloader.css({ width: 1 / img_tag.frames * img_tag.preloaded * (space.x - 40) });

									if( img_tag.frames == img_tag.preloaded ){
										$preloader.remove();
										var tH = 0;
										if( !philips.isIE ){
											tH = $overlay.find('> img').attr("height");
										}
										else{
											tH = $overlay.find('> img').height();
										}

										if( tH < 80 ){
											if( typeof this.viewer360 != 'undefined' ){
												this.viewer360._options.viewerElement.hide();
												this.viewer360.disabled = true;
											}
										}

										images.length || t.css({ backgroundImage: url(opt.path + image) });
										t
											.attr({ src: transparent })
											.trigger(opt.rows > 1 && !opt.stitched ? 'rowChange' : 'frameChange')
											.trigger('loaded')
											.trigger('opening');
										cleanup.call(e);
									}
								});

							$overlay.append($img);

							// The actual loading of the image is done asynchronously
							setTimeout((function( $img, uri ){
								return function(){
									$img.attr({ src: uri })
								}
							})($img, uri), 0);
						}
					},

					tick: function( e ){
						/*
						 - triggered by pool's `tick.reel` event
						 - keeps track of operated and braked statuses
						 - decreases inertial velocity by braking
						 */
						var velocity = get(_velocity_);

						if( braking ){
							var braked = lofi(velocity - (get(_brake_) / leader(_tempo_) * braking)),
								done = velocity * braked <= 0 || velocity < abs(braked),
								velocity = !done && set(_velocity_, velocity
									> abs(get(_speed_)) ? braked : (braking = operated = 0))
						}
						$monitor.text(get(opt.monitor));
						velocity && braking++;
						operated && operated++;
						to_bias(0);
						opt.slidable = true;

						if( operated && !velocity ){
							return cleanup.call(e);
						}

						if( get(_clicked_) ){
							return cleanup.call(e, unidle());
						}

						var backwards = get(_cwish_) * negative_when(1, get(_backwards_)),
							step = (get(_stopped_) ? velocity : abs(get(_speed_)) + velocity) / leader(_tempo_),
							was = get(_fraction_),
							fraction = set(_fraction_, was - step * backwards)

						cleanup.call(e);
						if( fraction == was ){
							return;
						}
						t.trigger('fractionChange');
					},
					opening: function( e ){
						/*
						 - initiates opening animation
						 - or simply plays the reel when without opening
						 */
						var
							speed = opt.entry || opt.speed,
							end = get(_fraction_),
							duration = opt.opening,
							start = set(_fraction_, end - speed * opt.opening),
							ticks = set(_opening_ticks_, duration * leader(_tempo_))
						pool.bind(_tick_, on.opening_tick);
					},
					opening_tick: function( e ){
						/*
						 - ticker listener dedicated to opening animation
						 */
						var
							speed = opt.entry || opt.speed,
							step = speed / leader(_tempo_) * (opt.cw ? -1 : 1),
							was = get(_fraction_),
							fraction = set(_fraction_, lofi(was + step)),
							ticks = set(_opening_ticks_, get(_opening_ticks_) - 1)

						t.trigger('fractionChange');
						cleanup.call(e);

						if( ticks > 1 ){
							return;
						}

						pool.unbind(_tick_, on.opening_tick);
						delay_play();
					},
					play: function( e, direction ){
						var
							playing = set(_playing_, true),
							stopped = set(_stopped_, !playing)
						idle();
						cleanup.call(e);
					},
					pause: function( e ){
						var
							playing = set(_playing_, false)
						unidle();
						cleanup.call(e);

					},
					stop: function( e ){
						var
							stopped = set(_stopped_, true),
							playing = set(_playing_, !stopped)
						cleanup.call(e);

					},
					down: function( e, x, y, touched ){
						/*
						 - starts the dragging operation by binding dragging events to the pool
						 */
						if( opt.draggable ){
							var
								clicked = set(_clicked_, get(_frame_)),
								velocity = set(_velocity_, 0),
								origin = last = recenter_mouse(x, y, get(_fraction_), get(_revolution_), get(_row_))
							unidle();
							no_bias();
							if( !touched ){
								stage_pool
									//.css({ cursor: url(drag_cursor_down)+', '+failsafe_cursor })
									.bind(_mousemove_, function( e ){
										t.trigger('slide', [e.clientX, e.clientY]);
										cleanup.call(e);
										return false
									})
								opt.clickfree || stage_pool.bind(_mouseup_, function( e ){
									t.trigger('up');
									cleanup.call(e)
								})
								t.show();
								opt.callBackOnStart();

							}
							//if($icon360) $icon360.hide();
						}
						cleanup.call(e);
					},
					up: function( e, touched ){
						/*
						 - ends dragging operation by calculating velocity by summing the bias
						 - unbinds dragging events from poolv
						 - resets the mouse cursor
						 */
						if( !opt.draggable ){
							return cleanup.call(e);
						}
						var
							clicked = set(_clicked_, false),
							reeling = set(_reeling_, false),
							velocity = set(_velocity_, !opt.throwable ? 0 : abs(bias[0] + bias[1]) / 60),
							brakes = braking = velocity ? 1 : 0
						velocity ? idle() : unidle();
						no_bias();
						!touched
						&& stage_pool.unbind(_mouseup_).unbind(_mousemove_);
						cleanup.call(e);
						//	if($icon360) $icon360.show();
						opt.callBackOnStop();

					},
					slide: function( e, x, y, touched ){
						/*
						 - calculates the X distance from drag center and applies graph on it to get fraction
						 - recenters the drag when dragged over limits
						 - detects the direction of the motion
						 - builds inertial motion bias
						 - (`slide` was originally `drag` which conflicted with MSIE)
						 */
						if( opt.draggable ){

							// by checking slidable sync with the ticker tempo is achieved
							opt.slidable = false;
							unidle();
							var
								delta = { x: x - last.x, y: y - last.y }
							if( abs(delta.x) > 0 || abs(delta.y) > 0 ){
								last = { x: x, y: y };
								var
									revolution = get(_revolution_),
									origin = get(_clicked_location_),
									vertical = get(_vertical_),
									fraction = set(_fraction_, graph(vertical ? y - origin.y : x
										- origin.x, get(_clicked_on_), revolution, get(_lo_), get(_hi_), get(_cwish_))),
									reeling = set(_reeling_, get(_reeling_) || get(_frame_) != get(_clicked_)),
									motion = to_bias(vertical ? delta.y : delta.x || 0),
									backwards = motion && set(_backwards_, motion < 0)
								if( opt.orbital && get(_center_) ){
									var
										vertical = set(_vertical_, abs(y - origin.y) > abs(x - origin.x)),
										origin = recenter_mouse(x, y, fraction, revolution, get(_row_))
								}
								if( opt.rows > 1 ){
									var
										space_y = get(_dimensions_).y,
										start = get(_clicked_row_),
										lo = -start * space_y,
										row = set(_row_, lofi($.reel.math.envelope(y - origin.y, start, space_y, lo, lo
											+ space_y, -1)))
								}
								var
									origin = !(fraction % 1) && !opt.loops
										&& recenter_mouse(x, y, fraction, revolution, get(_row_))
								t.trigger('fractionChange');
							}
						}
						cleanup.call(e);
					},
					wheel: function( e, distance ){
						/*
						 - calculates wheel input delta and adjusts fraction using the graph
						 - recenters the "drag" each and every time
						 - detects motion direction
						 - nullifies the velocity
						 */
						// console.log(e.type);

						// disable
						// @todo fix
						return true;

						if( !opt.wheelable ){
							return cleanup.call(e);
						}
						var
							delta = ceil(sqrt(abs(distance)) / 2),
							delta = negative_when(delta, distance > 0),
							revolution = 0.2 * get(_revolution_), // Wheel's revolution is just 20 % of full revolution
							origin = recenter_mouse(undefined, undefined, get(_fraction_), revolution, get(_row_)),
							fraction = set(_fraction_, graph(delta, get(_clicked_on_), revolution, get(_lo_), get(_hi_), get(_cwish_))),
							backwards = delta && set(_backwards_, delta < 0),
							velocity = set(_velocity_, 0)
						unidle();
						cleanup.call(e);
						t.trigger('fractionChange');
						return false;
					},
					fractionChange: function( e, fraction ){
						/*
						 - normalizes given fraction (if any) - loop/limit and round
						 - calculates and changes sprite frame
						 - for non-looping panoramas
						 - keeps track of ticks spent on edge
						 - reverses motion direction if too long
						 */
						var
							fraction = !fraction ? get(_fraction_) : set(_fraction_, fraction),
							fraction = opt.loops ? fraction - floor(fraction) : min_max(0, 1, fraction),
							fraction = set(_fraction_, lofi(fraction)),
							was = get(_frame_),
							frame = set(_frame_, 1 + floor(fraction / get(_bit_))),
							orbital = opt.orbital,
							center = set(_center_, !!orbital && (frame <= orbital || frame >= opt.footage - orbital
								+ 2))
						if( !opt.loops && opt.rebound ){
							var
								edgy = !operated && !(fraction % 1) ? on_edge++ : (on_edge = 0),
								bounce = on_edge >= opt.rebound * 1000 / leader(_tempo_),
								backwards = bounce && set(_backwards_, !get(_backwards_))
						}
						var
							space = get(_dimensions_),
							travel = (get(_vertical_) ? space.y : space.x) - opt.indicator,
							indicator = min_max(0, travel, round($.reel.math.interpolate(fraction, -1, travel + 2))),
							indicator = !opt.cw || opt.stitched ? indicator : travel - indicator,
							$indicator = $(dot(indicator_klass
								+ '.x'), get(_stage_)).css(get(_vertical_) ? { left: 0, top: indicator } : { left: indicator, top: space.y
								- opt.indicator });
						if( opt.rows > 1 ){
							var
								ytravel = get(_dimensions_).y - opt.indicator,
								yindicator = min_max(0, ytravel, round($.reel.math.interpolate(get(_row_), -1, ytravel
									+ 2))),
								$yindicator = $(dot(indicator_klass + '.y'), get(_stage_)).css({ top: yindicator })
						}
						if( frame == was && frame != 1 ){
							return cleanup.call(e);
						}
						t.trigger(opt.rows > 1 ? 'rowChange' : 'frameChange');
						cleanup.call(e);
					},
					rowChange: function( e, row ){
						/*
						 - recalculates frame from fraction in order to have fresh unshifted value
						 - shifts the stored frame to a desired row
						 */
						var
							frame = floor(get(_fraction_) / get(_bit_)) + 1,
							row = set(_row_, min_max(0, 1, lofi(row != undefined ? (row - 1) / (opt.rows
								- 1) : get(_row_)))),
							frame = set(_frame_, frame + (opt.rows <= 1 ? 0 : round(row * (opt.rows - 1)) * opt.frames))
						cleanup.call(e);
						t.trigger('frameChange');
					},
					frameChange: function( e, frame ){
						/*
						 - rounds given frame (if any) and calculates fraction using it
						 - calculates sprite background position shift and applies it
						 or changes sprite image
						 - adjusts indicator position
						 */
						var
							fraction = !frame ? get(_fraction_) : set(_fraction_, lofi(get(_bit_) * (frame - 1))),
							frame = set(_frame_, round(frame ? frame : get(_frame_))),
							images = opt.images,
							footage = opt.footage,
							space = get(_dimensions_),
							horizontal = opt.horizontal
						if( get(_vertical_) ){
							var
								frame = opt.inversed ? footage + 1 - frame : frame,
								frame = frame + footage
						}
						if( images.length ){
							var
								sprite = images[frame - 1]
							t.attr({ src: opt.path + sprite })

						}
						else{
							if( !opt.stitched ){
								var
									minor = (frame % footage) - 1,
									minor = minor < 0 ? footage - 1 : minor,
									major = floor((frame - 0.1) / footage),
									major = major + (opt.rows > 1 ? 0 : (get(_backwards_) ? 0 : get(_rows_))),
									spacing = get(_spacing_),
									a = major * ((horizontal ? space.y : space.x) + spacing),
									b = minor * ((horizontal ? space.x : space.y) + spacing),
									shift = images.length ? [0, 0] : horizontal ? [-b + _px_, -a + _px_] : [-a
										+ _px_, -b
										+ _px_]
							}
							else{
								var
									x = round(fraction * get(_stitched_travel_)),
									y = 0,
									shift = [-x + _px_, y + _px_]
							}
							t.css({ backgroundPosition: shift.join(___) })
						}
						cleanup.call(e);
					},
					// -----------------
					// [NEW] Annotations
					// -----------------
					//
					// If you want to annotate features of your scene to better describe the subject,
					// there's annotations for you. Annotations feature allows you to place virtually any
					// HTML content over or into the image and have its position and visibility synchronized
					// with the position of Reel. These two easy looking handlers do a lot more than to fit
					// in here.
					//
					// Learn more about [Annotations][1] in the wiki, where a great care has been taken
					// to in-depth explain this new exciting functionality.
					//
					// [1]:https://github.com/pisi/Reel/wiki/Annotations
					//
					'setup.annotations': function( e ){
						var
							space = get(_dimensions_),
							$overlay = t.parent(),
							film_css = { position: _absolute_, width: space.x, height: space.y, left: 0, top: 0 },
						//create div to hold all of the annotations
							$annotations = $('<div class="p-annotations"></div>').appendTo($overlay);

						$annotations.css({left: ($overlay.width() / 2) + opt.annotationOffset.x, top: ($overlay.height()
							/ 2) + opt.annotationOffset.y });
						$.each(get(_annotations_), function( ida, note ){
							var
								$note = typeof note.node == _string_ ? $(note.node) : note.node || {},
								$note = $note.jquery ? $note : $(tag(_div_), $note),
								$note = $note.attr({ id: ida }).addClass(annotation_klass),
								$image = note.image ? $(tag(_img_), note.image) : $(),
								$link = note.link ? $(tag('a'), note.link).click(function(){
									return false
								}) : $()

							css(hash(ida), { display: _none_, position: _absolute_ }, true);
							note.image || note.link && $note.append($link);
							note.link || note.image && $note.append($image);
							note.link && note.image && $note.append($link.append($image));

							//If the note is hidden from view initially then set the opacity to zero
							if( note.hidden ){
                                $note.css('visibility', 'hidden');
							}

							//If an onclick property is set the annotation will get wrapped with the onclick link
							if( note.onclick ){
								//$note = $note.wrap('<a class="annotationClick" href="javascript:void(0);" />').parent();
								$note.find('.p-tooltip-360').on('click', note.onclick );
							}

							$note.appendTo($annotations);
						});
					},
					'frameChange.annotations': function( e, frame ){
						var
							space = get(_dimensions_),
							stitched = opt.stitched,
							ss = get(_stitched_shift_)
						//if (!get(_preloaded_)) return;
						$.each(get(_annotations_), function( ida, note ){
							var
								frame = set(_frame_, round(frame ? frame : get(_frame_))), //Consider moving this above the loop
								$note = $(hash(ida)),
								start = note.start || 1,
								end = note.end,
								offset = frame - 1,
								at = note.at ? (note.at[offset] == '+') : false,
								offset = note.at ? offset : offset - start + 1,
								x = typeof note.x != _object_ ? note.x : note.x[offset],
								y = typeof note.y != _object_ ? note.y : note.y[offset],
								x3D = typeof note.x3D != _object_ ? note.x3D : note.x3D[offset],
								y3D = typeof note.y3D != _object_ ? note.y3D : note.y3D[offset],
								z3D = typeof note.z3D != _object_ ? note.z3D : note.z3D[offset],
								hide = typeof note.hide != _object_ ? note.hide : note.hide[offset],
								placed = x !== undefined && y !== undefined,
								visible = placed && (note.at ? at : (offset >= 0 && (!end || offset <= end - start)))
							if( stitched ){
								var
									on_edge = x < space.x && ss > stitched - space.x,
									after_edge = x > stitched - space.x && ss >= 0 && ss < space.x,
									x = !on_edge ? x : x + stitched,
									x = !after_edge ? x : x - stitched,
									x = x - ss
							}
							var
								style = { display: visible ? _block_ : _none_, position: _absolute_, left: px(x), top: px(y), webkitTransform: 'translate3d('
									+ px(x3D) + ', ' + px(y3D) + ', ' + px(z3D) + ')', MozTransform: 'translate3d('
									+ px(x3D) + ', ' + px(y3D) + ', ' + px(z3D)
									+ ')', transform: 'perspective(1800px) translate3d(' + px(x3D) + ', ' + px(y3D)
									+ ', ' + px(z3D) + ')' }; //use OTransform if opera ever supports 3D transforms

							$note.css(style);

							if( hide && !note.hidden ){
								$note.css('visibility', 'hidden');
								note.hidden = true;
							}
							else if( !hide && note.hidden ){
								$note.css('visibility', 'visible');
								note.hidden = false;
							}
						});
					},
					'up.annotations': function( e, ev ){
						// if (panned || wheeled) return;
						// var
						//   $target= $(ev.target),
						//   $link= ($target.is('a') ? $target : $target.parents('a')),
						//   href= $link.attr('href'),
						//   target= $link.attr('target') || 'self'
						// if (!href) return;
						// if (target == '_blank') panned= !!window.open(href)
						// else panned= !!(window[target].location.href= href)
					}
				},

			// Garbage clean-up facility called by every event
				cleanup = function( pass ){
					philips.isIE || delete this;
					return pass
				},

			// User idle control
				operated,
				braking = 0,
				idle = function(){
					return operated = 0
				},
				unidle = function(){
					clearTimeout(delay);
					pool.unbind(_tick_, on.opening_tick);
					t.trigger('play');
					return operated = -opt.timeout * leader(_tempo_)
				},
				delay,
			// Triggers "play" delayed or immediate play
				delay_play = function(){
					delay = setTimeout(function play(){
						t.trigger('play');
					}, opt.delay * 1000 || 0);
				},

				$monitor,
				$preloader,
				$icon360,
				indicator = function( axis ){
					return $(_div_tag_, {
						'class': [indicator_klass, axis].join(___),
						css: {
							width: opt.indicator,
							height: opt.indicator,
							overflow: _hidden_,
							top: get(_dimensions_).y - opt.indicator,
							left: 0,
							position: _absolute_,
							backgroundColor: _hex_black_
						}
					})
				},

				setSlidable = function(){
					opt.slidable = true;
				}

			// Inertia rotation control
			on_edge = 0,
				last = { x: 0, y: 0 },
				to_bias = function( value ){
					return bias.push(value) && bias.shift() && value
				},
				no_bias = function(){
					return bias = [0, 0]
				},
				bias = no_bias(),

				// Graph function to be used
				graph = opt.graph || $.reel.math[opt.loops ? 'hatch' : 'envelope'],

				// Resets the interaction graph's zero point
				recenter_mouse = function( x, y, fraction, revolution, row ){
					set(_clicked_on_, fraction);
					set(_clicked_row_, row);
					set(_lo_, opt.loops ? 0 : -fraction * revolution);
					set(_hi_, opt.loops ? revolution : revolution - fraction * revolution);
					return x && set(_clicked_location_, { x: x, y: y }) || undefined
				},
				setSlidable(),

				// no opera support
				//				stage_pool = $.browser.opera ? pool : $.unique(pool.add(window.top.document)),
				stage_pool = $.unique(pool.add(window.top.document)),

				// - CSS rules & stylesheet
				//
				css = function( selector, definition, global ){
					var
						stage = global ? __ : get(_stage_),
						selector = selector.replace(/^/, stage).replace(____, ____ + stage)
					return css.rules.push(selector + cssize(definition)) && definition
					function cssize( values ){
						var rules = [];
						$.each(values, function( key, value ){
							rules.push(key.replace(/([A-Z])/g, '-$1').toLowerCase() + ':' + px(value) + ';')
						});
						return '{' + rules.join(__) + '}'
					}
				}

			css.rules = [];
			on.setup();
		});

		ticker = ticker || (function tick(){
			var
				start = +new Date(),
				tempo = leader(_tempo_);
			if( tempo ){
				pool.trigger(_tick_);
				$.reel.cost = (+new Date() + $.reel.cost - start) / 2;
				return ticker = setTimeout(tick, max(4, 1000 / tempo - $.reel.cost));
			}
			else{
				return ticker = undefined
			}
		})();

		return $(instances);
	}

	// Mathematics core
	$.reel.math = {
		envelope: function( x, start, revolution, lo, hi, cwness ){
			return start + max(lo, min(hi, -x * cwness)) / revolution
		},
		hatch: function( x, start, revolution, lo, hi, cwness ){
			var
				x = (x < lo ? hi : 0) + x % hi, // Looping
				fraction = start + (-x * cwness) / revolution
			return fraction - floor(fraction)
		},
		interpolate: function( fraction, lo, hi ){
			return lo + fraction * (hi - lo)
		}
	}

	$.reel.touchy = (/iphone|ipod|ipad|android/i).test(navigator.userAgent);
	$.reel.lazy = (/iphone|ipod|android/i).test(navigator.userAgent);

	$.reel.instances = $();
	$.reel.cost = 0;

	function leader( key ){
		return $.reel.instances.length ? $.reel.instances.first().data(key) : null
	}

	$.reel.leader = leader;

	function add_instance( $instance ){
		return ($.reel.instances.push($instance[0])) && $instance
	}

	function remove_instance( $instance ){
		return ($.reel.instances = $.reel.instances.not('#' + $instance.attr(_id_))) && $instance
	}

	// Double plugin functions in case plugin is missing
	double_for('mousewheel disableTextSelect enableTextSelect'.split(/ /));

	// PRIVATE
	var
		pool = $(document),
	// 		browser_version= +$.browser.version.split('.').slice(0,2).join('.'),
	//		ie= $.browser.msie,
		knows_data_url = true, // ie7 not supported anymore
		failsafe_cursor = 'ew-resize',
		ticker,
		ticks = { before: 0, now: new Date() },

	// HTML classes
		klass = 'jquery-reel',
		overlay_klass = klass + '-overlay',
		indicator_klass = klass + '-indicator',
		preloader_klass = klass + '-preloader',
		monitor_klass = klass + '-monitor',
		hi_klass = klass + '-interface',
		annotation_klass = klass + '-annotation',

	// Image resources
		transparent = embedded('CAAIAIAAAAAAAAAAACH5BAEAAAAALAAAAAAIAAgAAAIHhI+py+1dAAA7') || cdn('blank.gif'),
		drag_cursor = embedded('EAAQAJECAAAAAP///////wAAACH5BAEAAAIALAAAAAAQABAAQAI3lC8AeBDvgosQxQtne7yvLWGStVBelXBKqDJpNzLKq3xWBlU2nUs4C/O8cCvU0EfZGUwt19FYAAA7')
			|| cdn('jquery.reel.cursor-drag.gif'),

	// drag_cursor_down = embedded('EAAQAJECAAAAAP///////wAAACH5BAEAAAIALAAAAAAQABAAQAIslI95EB3MHECxNjBVdE/5b2zcRV1QBabqhwltq41St4hj5konmVioZ6OtEgUAOw==') || cdn('jquery.reel.cursor-drag-down.gif'),
	// drag_cursor = '360cursor.gif',
	// drag_cursor_down = '360cursor.gif',

	// Shortcuts
		round = Math.round, floor = Math.floor, ceil = Math.ceil,
		min = Math.min, max = Math.max, abs = Math.abs, sqrt = Math.sqrt,
		number = parseInt,

	// Storage keys
		_annotations_ = 'annotations',
		_area_ = 'area', _backup_ = 'backup', _backwards_ = 'backwards', _bit_ = 'bit', _brake_ = 'brake', _center_ = 'center',
		_classes_ = 'classes', _clicked_ = 'clicked', _clicked_location_ = 'clicked_location',
		_clicked_on_ = 'clicked_on', _clicked_row_ = 'clicked_row', _cwish_ = 'cwish', _dimensions_ = 'dimensions',
		_fraction_ = 'fraction', _frame_ = 'frame', _frames_ = 'frames', _hi_ = 'hi', _hidden_ = 'hidden', _image_ = 'image',
		_opening_ticks_ = 'opening_ticks', _lo_ = 'lo', _playing_ = 'playing', _reeling_ = 'reeling', _revolution_ = 'revolution',
		_row_ = 'row', _rows_ = 'rows', _spacing_ = 'spacing', _speed_ = 'speed', _stage_ = 'stage',
		_steps_ = 'steps', _stitched_shift_ = 'stitched_shift', _stitched_ = 'stitched', _stitched_travel_ = 'stitched_travel', _stopped_ = 'stopped',
		_tempo_ = 'tempo', _velocity_ = 'velocity', _vertical_ = 'vertical', _wheel_step_ = 'wheel_step',

	// Events
		ns = '.reel',
		_dblclick_ = 'dblclick' + ns, _mousedown_ = 'mousedown' + ns, _mouseenter_ = 'mouseenter' + ns,
		_mouseleave_ = 'mouseleave' + ns, _mousemove_ = 'mousemove' + ns, _mouseup_ = 'mouseup' + ns,
		_mousewheel_ = 'mousewheel' + ns, _tick_ = 'tick' + ns, _touchcancel_ = 'touchcancel' + ns,
		_touchend_ = 'touchend' + ns, _touchstart_ = 'touchstart' + ns, _touchmove_ = 'touchmove' + ns,

	// Various string primitives
		__ = '', ___ = ' ', ____ = ',', _absolute_ = 'absolute', _div_ = 'div', _div_tag_ = tag(_div_),
		_height_ = 'height', _hex_black_ = '#000', _id_ = 'id', _img_ = 'img', _px_ = 'px', _src_ = 'src',
		_title_ = 'title', _width_ = 'width', _hex_grey_ = '#EEE', _block_ = 'block', _none_ = 'none', _object_ = 'object',
		_string_ = 'string';

	// Helpers
	function embedded( image ){
		return knows_data_url && 'data:image/gif;base64,R0lGODlh' + image
	}

	function tag( string ){
		return '<' + string + '/>'
	}

	function dot( string ){
		return '.' + string
	}

	function cdn( path ){
		return 'http://code.vostrel.cz/' + path
	}

	function url( location ){
		return 'url(' + location + ')'
	}

	function lofi( number ){
		return +number.toFixed(4)
	}

	function min_max( minimum, maximum, number ){
		return max(minimum, min(maximum, number))
	}

	function double_for( methods ){
		$.each(methods, pretend);
		function pretend(){
			if( !$.fn[this] ){
				$.fn[this] = function(){
					return this
				}
			}
		}
	}

	function negative_when( value, condition ){
		return abs(value) * (condition ? -1 : 1)
	}

	function finger( e ){
		return e.originalEvent.touches[0]
	}

	function hash( value ){
		return '#' + value
	}

	function px( value ){
		return value === undefined ? 0 : typeof value == _string_ ? value : value + 'px'
	}
})(jQuery, window, document);

/** @namespace */
;(function(window, $){

    var $html = $('html');

    window.philips = $.extend(window.philips, {
        toString : function(){
            return '[object philips]';
        },
        $document: $(document),
        $window  : $(window),
        $html    : $html,
        isIE8    : $html.hasClass('ie8'),
        isIE9    : $html.hasClass('ie9'),
        isIE     : /MSIE/g.test(window.navigator.userAgent),
        isRTL    : $html.attr('dir') === 'rtl'
    });

    $html.removeClass('no-js');

    $(function(){
        window.philips.$body = $('body');
    });

    // fix ie console
    if(window.console === undefined){
        window.console = {};
    }

    if(window.console.log === undefined){
        window.console.log = function(){
        };
    }

})(this, jQuery);
/**
 * Proxy for handling site wide events
 * @namespace
 * @fires resize
 **/
philips.events = philips.events || (function($){
    var
        $dispatcher = $({}),
        $document = philips.$document,
        $window = philips.$window,
        resizeTimer
        ;

    // extend the events with constants for custom events
    $dispatcher.extend({
        RESIZE: 'resize',
        LOAD: 'load',
        KEYDOWN: 'keydown',
        KEYUP: 'keyup',
        PICTUREFILL: 'picturefill',
        PICTUREFILL_LAZY: 'picturefillLazy',
        VIDEOSTOP: 'videostop'
    });

    if(philips.isIE8) {
        resizeOnScreenChange();
    } else {
        $window.resize(handleResize);
    }

    $window.load(handleLoad);
    $document.keydown(handleKeydown);
    $document.keyup(handleKeyup);

    if (window.picturefill) {
        window.picturefill.callback = handlePicturefill;
    }

    if(window.picturefillLazy) {
        window.picturefillLazy.callback = handlePicturefillLazy;
    }

    function resizeListener() {
        $(window).one("resize", function() {
            //unbinds itself every time it fires
            $dispatcher.trigger($dispatcher.RESIZE);
            //rebinds itself after 100ms
            setTimeout(resizeListener, 1000);
        });
    }

    /**
     * Handles resize event. When the screen width or screen height changed the resize handler trigger
     * fires once per x millis.
     * @method
     * @private
     */
    function resizeOnScreenChange() {
        var screenWidth     = $(window).width(),
            screenHeight    = $(window).height();

        $window.resize(function() {
            var newWidth = $(window).width(),
                newHeight = $(window).height();

            if (newWidth !== screenWidth || newHeight !== screenHeight) {
                screenWidth = newWidth;
                screenHeight = newHeight;
                handleResize();
            }
        });
    }

    /**
     * Handles resize event. Uses timeout to ensure responsive state event only
     * fires once per x millis.
     * @method
     * @private
     */
    function handleResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function(){
            // todo: parse width and height with trigger
            $dispatcher.trigger($dispatcher.RESIZE);
        }, 300);
    }

    /**
     * Handles resize event.
     * @method
     * @private
     */
    function handleLoad(e){
        $dispatcher.trigger($dispatcher.LOAD,e);
    }

    var pressedKeys = [];

    /**
     * Handles keydown event.
     * @method
     * @private
     */
    function handleKeydown(e){
        var keyCode = e.keyCode;
        pressedKeys[keyCode] = true;
        $dispatcher.trigger($dispatcher.KEYDOWN,keyCode);
    }

    /**
     * Handles keyup event.
     * @method
     * @private
     */
    function handleKeyup(e){
        var keyCode = e.keyCode;
        pressedKeys[keyCode] = false;
        $dispatcher.trigger($dispatcher.KEYUP,keyCode);
    }

    /**
     * Picturefill callback function.
     * @method
     * @private
     */
    function handlePicturefill(){
        $dispatcher.trigger($dispatcher.PICTUREFILL);
    }

    /**
     * PicturefillLazy callback function.
     * @method
     * @private
     */
    function handlePicturefillLazy(){
        $dispatcher.trigger($dispatcher.PICTUREFILL_LAZY);
    }

    return $dispatcher;
})(jQuery);
/**
 * A collection of generic utility functions.
 *
 * @namespace
 **/
philips.utilities = {
    toString      : function(){
        return '[object philips.utilities]';
    },
    LARGEST_NUMBER: 9007199254740992
};

/**
 * Prevents default event handling for anchor hyperlinks.
 */
philips.utilities.disableLinks = function(target){
    if(target !== "undefined" && target !== null){
        jQuery(target.selector + " a").bind("click", function(e){
            e.preventDefault();
        });
    }
};

/**
 * Test if variable is a number
 * @returns {boolean}
 */
philips.utilities.isNumber = function(n){
    return !isNaN(parseFloat(n)) && isFinite(n);
};

/**
 *
 * @param {function} assert An assert function to check against. Should return a boolean.
 * @param {function} callback The callback function if the assert function passes or the maxtime is reached.
 * @param {number} [time] Milliseconds interval to check.
 * @param {number} [maxtime] Maximum number of milliseconds to check.
 */
philips.utilities.timeoutAssert = function(assert, callback, time, maxtime){
    if(time === undefined){
        time = 100;
    }

    if(maxtime === undefined){
        maxtime = 3000;
    }

    var maxChecks = Math.floor(maxtime / time);

    function check(){
        if(maxChecks !== 0 && !assert()){
            setTimeout(check, time);
        }
        else{
            callback();
        }

        maxChecks--;
    }

    check();
};

/**
 * Image preloader
 * @param {Array} images The image uris to preload.
 * @param {function} loadDone The callback function parses an object with sizes of the loaded images.
 * @param {function} [loadError] The error function.
 */
philips.utilities.preloadImages = (function($){
    var imagePool = [];

    function getImage(){
        return imagePool.length === 0 ? document.createElement('img') : imagePool.pop();
    }

    function storeImage(image){
        $(image).off().removeAttr('src');
        imagePool.push(image);
    }

    function preloadImages(images, loadDone, loadError){
        var remainingImages = images.length,
            loadResult = {};

        function imageLoaded(e){
            var img = e.currentTarget;
            loadResult[img.getAttribute('src')] = {
                w: img.naturalWidth || img.width,
                h: img.naturalHeight || img.height
            };
            storeImage(e.currentTarget);
            remainingImages--;

            if(remainingImages === 0){
                loadDone(loadResult);
            }
        }

        for(var i = 0, l = images.length; i < l; i++){
            var src = images[i],
                img = getImage(),
                $img = $(img)
                ;
            $img.on('load', imageLoaded);

            if(loadError !== undefined){
                $img.on('error', loadError);
            }

            img.setAttribute('src', src);
        }
    }

    return preloadImages;
})(jQuery);

/**
 * Boolean to see if fullscreen API is present.
 * Code extracted from: http://johndyer.name/native-fullscreen-javascript-api-plus-jquery-plugin/
 */
philips.utilities.hasFullscreenAPI = (function(){
    var
        supportsFullScreen = false,
        prefix = '',
        browserPrefixes = 'webkit moz o ms khtml'.split(' ')
        ;
    // check for native support
    if(typeof document.cancelFullScreen !== 'undefined'){
        supportsFullScreen = true;
    } else{
        // check for fullscreen support by vendor prefix
        for(var i = 0, il = browserPrefixes.length; i < il; i++){
            prefix = browserPrefixes[i];
            if(typeof document[prefix + 'CancelFullScreen' ] !== 'undefined'){
                supportsFullScreen = true;
                break;
            }
        }
    }
    return supportsFullScreen;
})();

/**
 * Returns window width
 * @returns {number}
 */
philips.utilities.getWindowWidth = function(){
    return window.innerWidth || document.documentElement.clientWidth;
};

/**
 * Returns window height
 * @returns {number}
 */
philips.utilities.getWindowHeight = function(){
    return window.innerHeight || document.documentElement.clientHeight;
};

/**
 * Returns correct easing method
 * @param {string} easing easingMethod
 * @returns {string}
 */
philips.utilities.getEasing = function(easing){
    return philips.isIE8 || philips.isIE9 ? 'linear' : easing;
};

/**
 * Escapes the string
 * @param {string} the string to be escaped
 * @returns {string} the escaped string
 */
philips.utilities.escape = function(str){
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

/**
 * Escapes the string for tracking purposes
 * @param {string} the string to be escaped
 * @returns {string} the escaped string
 */
philips.utilities.stext = function(str, maxLength) {
    return String($.trim(str)).replace(/[^\w\s]/gi, '').replace(/\s/g, '_').toLowerCase().substr(0, maxLength || 40);
};
/** Set a user locale cookie on the page.
 *  when the remember_locale param is set in no3 country selector component in country selector page.
 **/
$(document).ready(function() {
   if(getUrlVars()['remember_locale'] !== undefined){
       locale = getUrlVars()['remember_locale'];
       var cookieStr = "userlocale\="+locale;
       $.cookie("Philips", cookieStr, {
           expires : 10
        });
   }
});

function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
/**
 * Loads the script without anti-caching timestamp.
 *
 * @param {string} the url of the script to be loaded
 * @param {function} the callback function (executed when script has been loaded)
 * @param {boolean} true to use asynchronous loading
 */
philips.utilities.loadScript = (function(window, $, undefined) {

    var promises = {};

    return function(url, callback, async) {
        if (!promises[url]) {
            promises[url] = $.ajax({
                url: url,
                type: 'get',
                dataType: 'script',
                async: async,
                cache: true
            });
        }

        if (callback) {
            promises[url].done(callback);
        }
        return promises[url];
    };

})(window, jQuery);
/**
* Handles the responsive state transitions
*
* @namespace
*/
philips.responsive = philips.responsive || (function(){

    var doc = window.document,
        events = philips.events,
        breakPoints = {"xs": 0, "s": 450, "m": 700, "l": 950},
        modes = ['unspecified', 'xs', 's', 'm', 'l'],
        mode = {
            /** @constant {integer} Unspecified responsive state */
            UNSPECIFIED: 0,
            /** @constant {integer} Responsive state between XS and S */
            XS: 1,
            /** @constant {integer} Responsive state between S and M */
            S: 2,
            /** @constant {integer} Responsive state between M and L */
            M: 3,
            /** @constant {integer} Responsive state greater than L */
            L: 4
        },
        currentMode = mode.UNSPECIFIED,
        $measuringTape = $('<div id="media-query-div"><style id="media-query-style">' +
                '#media-query-div {display:none!important;}' +
                '@media screen and (min-width: 1px){#media-query-div{height:1px!important}}' +
                '@media screen and (min-width: 961px){#media-query-div{height:4px!important}}' +
                '@media screen and (min-width: 701px) and (max-width:960px){#media-query-div{height:3px!important}}' +
                '@media screen and (min-width: 451px) and (max-width:700px){#media-query-div{height:2px!important}}' +
                '</style></div>'),
        isTapeAddedToDOM = false,
        returnObject = {
            toString: function(){return '[object responsive]';},
            mode: mode,
            modes: modes,
            getMode: getMode,
            MODE_CHANGE: 'modeChange'
        }
    ;

    // initialize
    events.on(events.RESIZE,checkModeChange);

    $(function(){
        currentMode = calculateMode();
    });

    /**
     * Used to respond to window resize event, and to determine if a breakpoint change has occurred
     *
     * @private
     * @fires modeChange oldMode currentMode
     */
    function checkModeChange() {
        var tempMode = calculateMode(),
            oldMode;
        if (currentMode !== tempMode) {
            oldMode = currentMode;
            currentMode = tempMode;
            events.trigger(returnObject.MODE_CHANGE, [oldMode, currentMode]);
        }
    }

    /**
     * Calculate the responsive state.
     *
     * @private
     * @returns {number} Returns an integer corresponding to philips.responsive.mode. constant
     */
    function calculateMode(){

        if (philips.isIE8) {
            return mode.L;
        }
        if (!isTapeAddedToDOM&&philips.$body) {
            addTapeToDOM();
        }
        var modeValue = parseInt($measuringTape.css('height'),10);
        //If media queries are not supported fallback on document.documentElement.clientWidth
        if(modeValue === mode.UNSPECIFIED || modeValue === null){
            var winWidth = document.documentElement.clientWidth;

            modeValue = setMode(modeValue, winWidth);
        }
        return modeValue;
    }

    /**
     * Calculate the responsive state.
     *
     * @private
     * @returns {number} Returns an integer corresponding to philips.responsive.mode. constant
     */
    function setMode(modeValue, winWidth) {
        if (winWidth > breakPoints.xs && winWidth < breakPoints.s) {
            modeValue = mode.XS;
        } else if (winWidth > breakPoints.s && winWidth < breakPoints.m) {
            modeValue = mode.S;
        } else if (winWidth > breakPoints.m && winWidth < breakPoints.l) {
            modeValue = mode.M;
        } else if (winWidth >= breakPoints.l) {
            modeValue = mode.L;
        }

        return modeValue;
    }

    /**
     * What is the responsive state?
     *
     * @public
     * @returns {number} Returns an integer corresponding to philips.responsive.mode. constant
     */
    function getMode(){
        return currentMode;
    }

    /**
     * Adds a DOM node containing CSS from which the responsive state can be read.
     */
    function addTapeToDOM(){
        $measuringTape.appendTo(philips.$body);
        isTapeAddedToDOM = true;
    }

    /**
     * Reset viewport zoom level is a workaround to fix a zoom bug in <= iOS5.
     * [Workaround explained on StackOverflow](http://stackoverflow.com/a/8807349)
     * @see fixIosOrientationChange
     *
     * @private
     */
    function resetViewportZoomLevel(){

        // Only apply is querySelector all is available
        if( !doc.querySelector ){
            return;
        }

        // Only if meta viewport is defined
        var metaViewport = doc.querySelector("meta[name=viewport]");

        if( !metaViewport ){
            return;
        }

        metaViewport.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=1;');
    }

    /**
     * fixIosOrientationChange
     * Fix zoom bug occuring on changing from portrait to landscape orientation in iOS.
     * Subscribes to orientation change event and trigger handle it by resetting the zoom.
     * Fix is for <= iOS5 only, as bug does not occur >= iOS6.
     *
     * @private
     */
    (function(){
        // This fix addresses an iOS bug, so return early if the UA claims it's something else.
        // [UA check borrowed from Scott Jehl](https://github.com/scottjehl/iOS-Orientationchange-Fix/blob/master/ios-orientationchange-fix.js)
        var ua = navigator.userAgent;
        if( !( /iPhone|iPad|iPod/.test(navigator.platform) && /OS [1-5]_[0-9_]* like Mac OS X/i.test(ua) && ua.indexOf("AppleWebKit") > -1 ) ){
            return;
        }
        window.addEventListener('orientationchange', resetViewportZoomLevel, false);
    })();

    return returnObject;
})();
/**
* Non Browser Notification Bar.
* Namespace with a factory creating component instances on document.ready.
* @namespace
*/
philips.utilities.nonBrowserNotificationBar = (function($){
    var
        /**
         * Collection of component instances.
         *
         * @member {Array} instances
         * @memberOf philips.components.aggregated.nonBrowserNotificationBar
         * @access public
         * @see nonBrowserNotificationBarInstance
         */
        instances = [],
        // jQuery collection of component instances.
        $components
    ;

    if($){
        // Initialise components on document ready.
        $(function(){
            $components = $('.p-non-browser-notification-bar');
            $components.each(function () {
                create(this);
            });
        });
    }

    /**
     * Create a component.
     *
     * @memberOf philips.components.aggregated.nonBrowserNotificationBar
     * @access public
     * @param {HTMLElement} component The component HTMLElement.
     * @returns {nonBrowserNotificationBarInstance} The component instance.
     */
    function create(component){
        var
            $component = $(component),
            $notificationBar = $component.find('.p-notification-bar'),
            ieBrowserVersion = $('html').hasClass('ltie8') ? true : false,
            notificationBar  = $.cookie('browserNotification'),

            /**
             * nonBrowserNotificationBar instance.
             * @namespace nonBrowserNotificationBarInstance
             * @see philips.components.aggregated.nonBrowserNotificationBar
             * @instance
             */
            instance = {
                toString: function(){return '[object NonBrowserNotificationBar instance]';},
                component: $component,
                render: render
                // Other possible public component instance methods.
            }
        ;

        // Call custom tracking function.
        tracking();

        // Store the instance in jQuery DOM element for later retrieval.
        $component.data('nonBrowserNotificationBar', instance);

        // Push component to components Array instances list.
        instances.push(instance);

        // Display the ie notification bar
        if((ieBrowserVersion !== false) && (notificationBar === undefined)) {
            $component.show();
        }

        // Hide the notification bar if close button clicked.
        $notificationBar.find('.p-close-button').on('click', function() {
            $component.hide();
            $.cookie('browserNotification', 1);
        });

        /**
         * Tracking is used to track user interaction, add your custom code
         * to track the different user interactions.
         *
         * @member {Function} tracking
         * @memberOf nonBrowserNotificationBarInstance
         * @access private
         */
        function tracking() {
            // Put custom tracking code here.
        }

        /**
         * Optional public example method, you can use this for instance to re-render
         * the component.
         *
         * @member {Function} render
         * @memberOf nonBrowserNotificationBarInstance
         * @access public
         */
        function render() {

        }

        // Returns the instance.
        return instance;
    }

    // Return the namespace.
    return {
        toString: function(){return '[object NonBrowserNotificationBar]';},
        instances: instances,
        create: create
    };
})(jQuery);
philips.utilities.passwordMeter = (function() {

    var LOWER = /[a-z]/,
        UPPER = /[A-Z]/,
        DIGIT = /[0-9]/,
        DIGITS = /[0-9].*[0-9]/,
        SPECIAL = /[^a-zA-Z0-9]/,
        SAME = /^(.)\1+$/;

    function validate($input, $meter) {
        var rating = ratePassword($input.val());

        $meter.show();

        $meter.find('.p-password-meter-bg').removeClass().addClass('p-password-meter-bg').addClass('p-password-meter-' + rating.messageKey);
        $meter.find('.p-password-meter-bar').removeClass().addClass('p-password-meter-bar').addClass('p-password-meter-' + rating.messageKey);
        $meter.find('.p-password-meter-message').removeClass()
            .addClass('p-password-meter-message')
            .addClass('p-password-meter-message-' + rating.messageKey)
            .text($meter.data('password-' + rating.messageKey) || '');

        return rating.rate > 0;
    };

    function ratePassword(password) {
        if (!password || password.length < 8 || SAME.test(password)) {
            return rating(0, 'weak');
        }

        var lower = LOWER.test(password),
            upper = UPPER.test(uncapitalize(password)),
            digit = DIGIT.test(password),
            digits = DIGITS.test(password),
            special = SPECIAL.test(password);

        if (lower && upper && digit || lower && digits || upper && digits || special) {
            return rating(2, 'strong');
        }
        return rating(1, 'medium');
    };


    function rating(rate, message) {
        return {
            rate: rate,
            messageKey: message
        };
    }

    function uncapitalize(str) {
        return str.substring(0, 1).toLowerCase() + str.substring(1);
    }

    return {
        validate: validate
    };

})();
/** @namespace */
philips.libs = {};
/**
 * Function used to divide array of elements in to multiple column
 * There are two modes avaiable
 * Option 1- Divided element equally with count per column
 * Option 2- Divided by setting equal height of content(approx).
 * @param args - options
 * options.equalCount - true for using option 1 , false for option 2
 * options.sel - selector for html dom as jquery object
 * options.el - selector for element used for array
 * options.colNum - number of column.
 * options.cloneSel - immediate  parent of element in array
 * @constructor
 */
philips.libs.multicolumn = function(options) {
    //cloneSel required when used in table where immediate parent is not to be clone
    //and also useful when elements(table or ul is under div with grid item class)
    var equalCount = options.equalCount,
        sel        = options.sel,
        el         = options.el,
        colNum     = options.colNum,
        cloneSel   = options.cloneSel,
        events     = philips.events
        ;
    if(sel.find(el).length < 2) {
        return false;
    }
    var elParent  = sel.find(el).parent()[0].nodeName;
    cloneObj = $(sel.find(cloneSel));
    var colmaxHeight = cloneObj.height()/colNum;
    if(colmaxHeight < 1){
        equalCount = true;
    }
    var elCountPerColumn =  Math.round(sel.find(el).length/colNum);
    //creating new columns
    for(var i=0; i<colNum; i++) {
        var t = cloneObj.clone();
        $(t).find(el).remove();
        $(cloneObj.parent()).append(t);
    }
    var addEementToColumn = function(newcol, appendTo){
        cloneObj.find(el).each(function(){
            if((newcol.height() + ($(cloneObj.find(el)[0]).height() /2)) > colmaxHeight){
                return false;
            }
            appendTo.append(cloneObj.find(el)[0]);
        });
    };
    for(var ix=1; ix<=colNum; ix++){
        var newcol = $(sel.find(cloneSel)[ix]);
        var appendTo =  (newcol.find(elParent).length > 0)? newcol.find(elParent): newcol;
        if(equalCount){
            for(var j=0;j<elCountPerColumn; j++){
                appendTo.append(cloneObj.find(el)[0]);
            }
        }else {
                addEementToColumn(newcol, appendTo);
        }
    }
    cloneObj.remove();
    events.on(events.LOAD, function(){
        sel.find(cloneSel).each(function(){
           $(this).find(el).last().addClass("p-last");
        });
        sel.find(cloneSel).last().addClass("p-last");
    });
};
/**
 * Generic caroussel component
 * Assumes DOM of the following structure: div>ul>li*20 (nodenames can be anything). So a wrapper element (overflow:hidden), an inner wrapper element (moves) and an x-number of child elements.
 * @namespace
 * @property {Array} instances
 * @property {Function} toString
 * @returns {Object}
 */

philips.libs.carousel = (function($){

    function Carousel(outerWrapper, options){

        // extend options with defaults
        this._options = $.extend({
            fullItems      : true,
            swipeNavigation: true,
            animate        : Carousel.ANIMATE_ROW
        }, options || {});

        this._isAnimateSingle = this._options.animate === Carousel.ANIMATE_SINGLE;

        this._$outerWrapper = $(outerWrapper);
        this._elements = [];
        this._items = [];

        this.initialize();
    }

    Carousel.toString = function(){
        return '[object carousel]';
    };

    /**
     * ...
     *
     * @param outerWrapper
     * @param options
     */
    Carousel.instantiate = function(outerWrapper, options){
        var car = new Carousel(outerWrapper, options);
        this.instances.push(car);
        return car;
    };


    // events
    // before animation
    Carousel.INDEX_CHANGE = 'indexChange';
    // after animation
    Carousel.INDEX_CHANGED = 'indexChanged';

    // parameters
    Carousel.ANIMATE_ROW = 'animateRow';
    Carousel.ANIMATE_SINGLE = 'animateSingle';

    Carousel.classnameCaroussel = 'p-carousel';
    Carousel.classnameAnimateSingle = 'p-animate-single';
    Carousel.instances = [];

    // private
    Carousel.prototype._outerW = 0;
    Carousel.prototype._outerH = 0;
    Carousel.prototype._innerW = 0;
    Carousel.prototype._innerH = 0;
    Carousel.prototype._itemPadding = 0;
    Carousel.prototype._itemMargin = 0;
    Carousel.prototype._items;
    Carousel.prototype._$items;
    Carousel.prototype._$firstItem;
    Carousel.prototype._$outerWrapper;
    Carousel.prototype._currentIndex = 0;
    Carousel.prototype._isAnimateSingle = false;
    Carousel.prototype._animationMillis = 500;

    // public
    Carousel.prototype.initialize = function(){

        this._$innerWrapper = this._$outerWrapper.children(':first');
        this._$items = this._$innerWrapper.children();
        this._items = this._$items.toArray();
        this._$firstItem = this._$items.filter(':first');
        this.length = this._items.length;

        if(this._isAnimateSingle){
            this.setOtherItemsPos();
        }

        this._$outerWrapper.addClass(Carousel.classnameCaroussel);
        if(this._isAnimateSingle){
            this._$outerWrapper.addClass(Carousel.classnameAnimateSingle);
        }

        philips.events.on(philips.events.RESIZE, this.onResize.bind(this));
        // todo: size in p18 pex sometimes off... find out why
        setTimeout(this.onResize.bind(this), 40);


        // keyboard events
        var self = this;
        philips.events.on(philips.events.KEYUP, function(keyCode){

            if(keyCode === 37){
                self.previous();
            }
            else if(keyCode === 39){
                self.next();
            }
        });

        // touch gestures
        if(typeof(window.Hammer) !== 'undefined' && this._options.swipeNavigation){
            this._$outerWrapper
                .hammer({drag_max_touches: 0})
                .on('swipeleft', this.next.bind(this))
                .on('swiperight', this.previous.bind(this));
        }
    };

    Carousel.prototype.toString = function(){
        return '[object carousel instance]';
    };

    Carousel.prototype.getIndex = function(){
        return this._currentIndex;
    };

    Carousel.prototype.setIndex = function(newIndex, dontAnimate){
        if(typeof(newIndex) === 'undefined'){
            newIndex = 0;
        }

        newIndex = Math.min(Math.max(newIndex, 0), this.length - 1);

        if(this.enabled && this._currentIndex !== newIndex){
            var oldIndex = this._currentIndex;
            this._currentIndex = Math.min(Math.max(newIndex, 0), this.length - 1);
            this.setInnerPosition(dontAnimate, oldIndex);
            this._$outerWrapper.trigger(Carousel.INDEX_CHANGE, [this._currentIndex, oldIndex]);
        }

        return this._currentIndex;
    };

    Carousel.prototype.setIndexById = function(id, dontAnimate){
        var $item = this._$items.filter('#' + id),
            currentIndex = this.getIndex();
        if($item.length){
            currentIndex = this.setIndex($item.index(), dontAnimate);
        }
        return currentIndex;
    };

    Carousel.prototype.getCurrentId = function(){
        return this.getCurrentElement().getAttribute('id');
    };

    Carousel.prototype.getCurrentElement = function(){
        return this.getElementByIndex(this._currentIndex);
    };

    Carousel.prototype.getElementByIndex = function(i){
        return this._$items[i];
    };

    Carousel.prototype.previous = function(){
        return this.setIndex(this._currentIndex - 1);
    };

    Carousel.prototype.next = function(){
        return this.setIndex(this._currentIndex + 1);
    };

    Carousel.prototype.resize = function(){
        if(this.enabled){

            // set variables
            this._outerW = this._$outerWrapper.width();
            this._outerH = this._$outerWrapper.height();
            this._itemPadding = parseInt(this._$firstItem.css('padding-left'), 10) +
                parseInt(this._$firstItem.css('padding-right'), 10);
            this._itemMargin = parseInt(this._$firstItem.css('margin-left'), 10) +
                parseInt(this._$firstItem.css('margin-right'), 10);

            this.calculateInnerWidth();

            // set view
            this.setInnerSize();
            this.setInnerPosition(true);
        }
    };

    // todo: document
    Carousel.prototype.setOtherItemsPos = function(){
        this._$items.not(':eq(' + this._currentIndex + ')').css({left: -4 * philips.$body.width() });
    };

    Carousel.prototype.indexOf = function(search, value){
        return this._elements.indexOf(search, value);
    };

    Carousel.prototype.length = 0;
    //
    Carousel.prototype.enabled = true;

    Carousel.prototype.enable = function(){
        if(!this.enabled){
            this.enabled = true;
            this._$outerWrapper.addClass(Carousel.classnameCaroussel);
            this.onResize();
        }
    };

    Carousel.prototype.disable = function(){
        if(this.enabled){
            this.enabled = false;
            this._$outerWrapper.removeClass(Carousel.classnameCaroussel);
            this._$innerWrapper.removeAttr('style');
            this._$items.removeAttr('style');
        }
    };

    //
    // todo: document
    Carousel.prototype.on = function(type, fn){
        this._$outerWrapper.on(type, fn);
    };

    Carousel.prototype.onResize = function(){
        if(this.enabled){

            // set variables
            this._outerW = this._$outerWrapper.width();
            this._outerH = this._$outerWrapper.height();
            this._itemPadding = parseInt(this._$firstItem.css('padding-left'), 10)
                + parseInt(this._$firstItem.css('padding-right'), 10);
            this._itemMargin = parseInt(this._$firstItem.css('margin-left'), 10)
                + parseInt(this._$firstItem.css('margin-right'), 10);
            this.calculateInnerWidth();

            // set view
            this.setInnerSize();
            this.setInnerPosition(true);
        }
    };

    Carousel.prototype.handleResize = Carousel.prototype.onResize;
    Carousel.prototype.calculateInnerWidth = function(){
        if(this._options.fullItems){
            this._innerW = this.length * this._outerW;
        }
        else{
            this._innerW = 0;
            var self = this;
            this._$items.each(function(){
                var $item = $(this);
                self._innerW += $item.width() + parseInt($item.css('margin-left'), 10) +
                    parseInt($item.css('margin-right'), 10);
            });
        }
    };

    Carousel.prototype.setInnerSize = function(){
        this._$innerWrapper.width(this._innerW);
        if(this._options.fullItems){
            this._$items.width(this._outerW - this._itemPadding);
            this.setOtherItemsPos();
        }
    };

    Carousel.prototype.setInnerPosition = function(dontAnimate, oldIndex){
        var self = this;
        if(dontAnimate){
            if(this._isAnimateSingle){
                $(this.getCurrentElement()).css({left: '0px'});
                this.setOtherItemsPos();
            }
            else{
                this._$innerWrapper.css({left: -this._outerW * this._currentIndex });
            }
        }
        else{
            if(this._isAnimateSingle){
                var moveLeft = this._currentIndex > oldIndex,
                    $oldSlide = $(this.getElementByIndex(oldIndex)),
                    $nowSlide = $(this.getCurrentElement());
                //
                $oldSlide.animate({
                        left: moveLeft ? -this._outerW : 2 * this._outerW },
                    this._animationMillis, philips.utilities.getEasing('easeInOutQuad')
                );
                //
                $nowSlide.css({left: moveLeft ? 2 * this._outerW : -this._outerW}).show();
                $nowSlide.animate({left: '0px'}, {
                    duration: this._animationMillis,
                    easing  : philips.utilities.getEasing('easeInOutQuad'),
                    complete: function(){
                        self.setOtherItemsPos();
                        self._$outerWrapper.trigger(Carousel.INDEX_CHANGED, self.getIndex());
                    }
                });
            }
            else{
                this._$innerWrapper.animate({
                    left: -this._outerW * this.getIndex()
                }, {
                    duration: this._animationMillis,
                    easing  : philips.utilities.getEasing('easeInOutQuad'),
                    complete: function(){
                        self._$outerWrapper.trigger(Carousel.INDEX_CHANGED, self.getIndex());
                    }
                });
            }
        }
    };
    return Carousel;
})(jQuery);
/**
 * Viewer360
 *
 * @namespace
 */
philips.libs.viewer360 = (function($){
    var
    // description of an exposed property
        /**
         * Collection of component instances
         *
         * @member {Array} instances
         * @memberOf philips.libs.viewer360
         * @access public
         * @see x00ScaffoldInstance
         */
            instances = [],
    // description of a private property
        /**
         * jQuery Collection of component instances
         *
         * @member {Array} $components
         * @memberOf philips.libs.viewer360
         * @access private
         */

            // Static properties
            sizes = [
            'unspecified', // unspecified
            [180, 200, 0.5], // x
            [282, 314, 0.785], // xs
            [296, 329, 0.8225], // m
            [301.5, 335, 0.8375] // l
        ],

        vec2 = {},

        defaults = {
            hotspots: true,
            debug: true,
            imageurl: '',
            hotspotsurl: '',
            activeAndLoading: true,
            viewerElement: null
        }
        ;

    /**
     * Subtracts two vec2's
     *
     * @param {vec2} out the receiving vector
     * @param {vec2} a the first operand
     * @param {vec2} b the second operand
     * @returns {vec2} out
     */
    vec2.subtract = function( out, a, b ){
        out.x = a[0] - b[0];
        out.y = a[1] - b[1];
        return out;
    };

    // description of an exposed method
    /**
     * Factory method to create a component
     *
     * @memberOf philips.libs.viewer360
     * @access public
     * @param {HTMLElement} component The component HTMLElement
     * @returns {Viewer360Instance} The component instance
     */
    function create(component, options){
        var $component = $(component),

            hotspotData = '',
            imageData = '',

            _imgcount = 0,

            annotations,
            annotationOffset,

            _currentAsset,

            _scaleFactor = 1,
            _options = $.extend(defaults, options || {}), // object
            _imagecount = 72, // number
            _imagedata, // array
            _imagekeys, // array
            _loadeddata = 0, // number
            _loaderdiv = null, // HTMLElement
            _pex = null, // Pex
            _viewer360Img = null, // JQueryElement
            _viewer360MobileTooltipHolder = null, // JQueryElement

            _imageWidth = -1, // number
            _imageHeight = -1, // number

            _viewer360Img_reel = null, // _viewer360Img_reel

            _hotspotHalfWidth = 34 / 2,
            _hotspotHalfHeight = 32 / 2,

            _zeroX = 0,
            _zeroY = 0,

            disabled = false,

            lt_IE9,

            /**
             * The returned instance. Define the public API here.
             *
             * @member {object} Viewer360Instance
             * @instance
             */
                instance = {
                toString: function(){return '[object viewer360 instance]';},
                component: $component,
                render: render,
                start: _onStart,
                reset: _onReset
                // other possible public component instance methods
            };

        _loaderdiv = $('<p style="padding-top:100px; text-align: center;">' + ($component.attr('data-360-loading-text') || '...') + '</p>');
        _options.viewerElement.append(_loaderdiv);

        _options.viewerElement.append($('<a class="p-close p-viewer-close">' + ($component.attr('data-360-close-text') || 'Close') + '<i class="p-circle p-icon-close-01"></i></a>').on('click', _onResetCloseView));

        philips.events.on(philips.responsive.MODE_CHANGE, onModeChange);

        _viewer360Img = $(document.createElement('img')).attr('class', 'viewer360Img');
        _options.viewerElement.append(_viewer360Img);

        _viewer360MobileTooltipHolder = $(document.createElement('div')).addClass('p-viewer360-tooltips');
        _options.viewerElement.append(_viewer360MobileTooltipHolder);

        $.when(
            // Load images
            getViewer360Data(_options.imageurl, 'handler', createUniqueCallbackName(['IS',getImageSetName(_options.imageurl)]), 'imageSet'),

            // load hotspots
            getViewer360Data(_options.hotspotsurl, false, 'hotSpotData', 'hotspots')
        ).then(function () {
                if(hotspotData !== '') {
                    hotSpotData(hotspotData);
                }

                if(imageData !== '') {
                    s7jsonResponse(imageData);
                }
        }).fail();

        function getImageSetName(url) {
            // Get the name of the image set
            if(url !== '') {
                var pathArray   = url.split('/'),
                    imgName     = pathArray[6].split('?');

                return imgName[0];
            }
        }

        function createUniqueCallbackName (params) {
            // Create a unique cache key based on the url as callback name
            return ('cb' + params.join('')).replace(/-|_/g,'');
        }

        function getViewer360Data(url, handler, callback, type) {
            if(url === '') {
                return;
            }

            return $.ajax({
                url : url,
                dataType : 'jsonp',
                jsonp: handler,
                jsonpCallback: callback,
                cache: true,
                success: function(data) {
                    if(type === 'hotspots') {
                        hotspotData = data || {};
                    } else {
                        imageData = data || [];
                    }
                },
                error: function() {
                }
            });
        }

        function dataIsLoaded(){
            _loadeddata++;

            var totalCounter = (_options.imageurl !== '' && _options.hotspotsurl !== '') ? 2 : _loadeddata;

            if( _loadeddata === totalCounter && _options.activeAndLoading ){
                launch(function(){
                    // trigger mode change for first check.
                    onModeChange(null, null, philips.responsive.getMode());
                });
            }
        }

        /**
         *
         * @param {JQuery.Event} event
         * @param {number} from
         * @param {number} to
         */
        function onModeChange( event, from, to ){

            var mode = philips.responsive.mode;

            _scaleFactor = sizes[to][2];
            setSize( sizes[to][0], sizes[to][1] );

            if ((from === null || from <= mode.S) && to >= mode.M) {
                initNormalMode();
            } else if ((from === null || from >= mode.M) && to <= mode.S) {
                initSmallMode();
            }
        }

        function initNormalMode(){
            var annotations = $component.find('.p-annotations .jquery-reel-annotation');
            var $elements = annotations.find('.p-tooltip-360');
            _viewer360MobileTooltipHolder.off('.tooltip-mobile');

            $elements.each(function(i){
                $(this).css('display', 'block');
                var hotspotTarget = _pex.views.Explore.content.Hotspot[i];
                if (Modernizr.touch) {
                    $(this).on('touchstart', function(){
                        addPopUpHandler(hotspotTarget);
                    });
                } else {
                    $(this).on('click', function(){
                        addPopUpHandler(hotspotTarget);
                    });
                }
                $(this).appendTo(annotations[i]);
            });
        }

        function initSmallMode(){

            var annotations = $component.find('.p-annotations .jquery-reel-annotation');

               // close mobileTooltip on click outside
            _options.viewerElement.on('touchstart click', function(e){
                if (!$(e.target).hasClass('jquery-reel-annotation') && !$(e.target).parents('.p-tooltip-360')[0]) {
                    _viewer360MobileTooltipHolder.find('.p-tooltip-360').css('display', 'none');
                }
            });

            annotations.each(function( i, el ){
                $(el).off('.tooltip-mobile');

                if (Modernizr.touch) {
                    doTooltipMobile(i, el, 'touchstart');
                } else {
                    doTooltipMobile(i, el, 'click');
                }

                var tooltip = $(el).find('.p-tooltip-360');
                tooltip.css('display', 'none');
                tooltip.attr('data-dom-position', i);
                tooltip.appendTo(_viewer360MobileTooltipHolder);
            });

        }

        function doTooltipMobile(index, element, eve){
            var eveTooltip = eve + '.tooltip-mobile';
            $(element).on(eveTooltip, function(){
                _viewer360MobileTooltipHolder.find('.p-tooltip-360').css('display', 'none');
                var $tooltipTarget = $(_viewer360MobileTooltipHolder.find('.p-tooltip-360')[index]);
                $tooltipTarget.css('display', 'block');
                $tooltipTarget.off(eve);
                $tooltipTarget.on(eve, function(){
                    var hotspotTarget = _pex.views.Explore.content.Hotspot[index];
                    addPopUpHandler(hotspotTarget);
                });
            });
        }

        function setImageData( arr ){
            // Remove any image that does not end in atleast two numbers
            _imagekeys = arr || [];
            _imagedata = [];
            var las2nums = /\d\d$/;

            // returns the last two characters of a string if they are digits
            for( var i = 0; i < _imagekeys.length; i++ ){
                if( _imagekeys[i].match(las2nums) === null ){
                    _imagekeys.splice(i, 1);
                }
            }

            // Sort array alphabetically to ensure that images are in the correct order
            _imagekeys.sort();
        }

        function setSize( width, height ){
            var hotspot;

            if( _viewer360Img_reel ){

                $component.find('.p-annotations').hide();

                _viewer360Img_reel.parent().css({width:width,height:height});
                _viewer360Img_reel.css({width:width,height:height});

                $component.find('.p-annotations').css({
                    left: width/2 + (annotationOffset.x * _scaleFactor),
                    top: height/2 + (annotationOffset.y * _scaleFactor)
                });

                for( var i in annotations ){
                    if( annotations.hasOwnProperty(i) ){
                        hotspot = annotations[i];

                        if(typeof(hotspot.original_x) !== 'undefined' && typeof(hotspot.original_x.length) !== 'undefined'){
                            for( var j = 0; j < hotspot.original_x.length; j++ ){
                                hotspot.x[j] = hotspot.original_x[j] * _scaleFactor;
                                hotspot.y[j] = hotspot.original_y[j] * _scaleFactor;
                            }
                        } else if(typeof(hotspot.x3D) !== 'string'){
                            for( var k = 0; k < hotspot.original_x3D.length; k++ ){
                                hotspot.x3D[k] = hotspot.original_x3D[k] * _scaleFactor;
                                hotspot.y3D[k] = hotspot.original_y3D[k] * _scaleFactor;
                                hotspot.z3D[k] = hotspot.original_z3D[k] * _scaleFactor;
                            }
                        } else {
                            hotspot.x = hotspot.original_x * _scaleFactor;
                            hotspot.y = hotspot.original_y * _scaleFactor;
                        }
                    }
                }

                setTimeout(function(){
                    $component.find('.p-annotations').show();

                    _onReset(null, true);
                }, 200);
            }

        }

        function s7jsonResponse( json ) {
            // Break Image data into array
            setImageData(json.IMAGE_SET.split(','));
            // Add image extension
            for( var i = 0; i < _imagekeys.length; i++ ){
                //".jpg" // set .jpg for testing purpose
                _imagedata.push('http://images.philips.com/is/image/' + _imagekeys[i] + '?wid=300&hei=255&$jpglarge$');
            }

            //Set image count and base image URL
            _imagecount = _imagekeys.length;

            // Clear still loading info
            _loaderdiv.remove();

            _options.viewerElement.find('.viewer360Img').css('display', 'block');

            dataIsLoaded();
        }

        function hotSpotData( json ){
            _pex = json.pex;
            dataIsLoaded();
        }

        function show() {
            $component.css({ 'opacity': '1' });
            $component.parents('.p-viewer360-pex-area').data('p18PexArea').showReset();
        }

        function hide(){
            $component.css({ 'opacity': '0' });
            $component.parents('.p-viewer360-pex-area').data('p18PexArea').hideReset();
        }

        function launch( callback ){
            if( _options.imageurl !== _currentAsset ){

                if( typeof _options.viewerElement === "undefined" || _options.viewerElement === null ){
                    return;
                }

                hide();

                // On P3D launch. Check if image data was returned
                if( _imagedata === null ){
                    // If not set activeAndLoading to true
                    _options.activeAndLoading = true;
                    // Display data still loading
                    return;
                }
                // Otherwise imageData is loaded and 360 can be displayed

                // Set flag for if browser is IE and version is less than 9
                if( philips.isIE8 ){
                    lt_IE9 = true;
                } else {
                    lt_IE9 = false;
                }

                if(_imagedata) {
                    _viewer360Img.attr("src", _imagedata[0] );
                } else {
                    _viewer360Img.attr("src", $component.parents('.p-viewer360-pex-area').find('.p-normal-view img')[0].src );
                }

                // Once the base image is loaded, initialize the viewer360 reel
                // The reel() plugin will load in the rest of the image sequence.
                _options.viewerElement.addClass('p-load-image');

                var loadFirstImage = function() {
                    setTimeout(function(){
                        _options.viewerElement.removeClass('p-load-image');

                        //Set Image width and height
                        _imageWidth = parseInt(_viewer360Img[0].width, 10);
                        _imageHeight = parseInt(_viewer360Img[0].height, 10);

                        //Convert hotspot data to annotations object for jQuery reel
                        annotations = {};
                        var hotspots = [];

                        annotationOffset = {x: 0, y: 0};

                        // Items without an fov of 70 will have the hotspots ignored
                        if( _pex !== null && _pex.views.Explore.content && _pex.views.Explore.content.Hotspot && _options.hotspots ){
                            hotspots = _pex.views.Explore.content.Hotspot;

                            annotationOffset.x = parseInt(_pex.views.Explore.content.offsetX, 10);
                            annotationOffset.y = parseInt(_pex.views.Explore.content.offsetY, 10);

                            _configureHotspots(hotspots, annotations, annotationOffset);
                        }

                        try {
                            $component.parents('.p-viewer360-pex-area').data('p18PexArea').loaded360view();
                            _viewer360Img_reel = _viewer360Img.reel({
                                _wrapper: $component,
                                frames: _imgcount,
                                saves: true,
                                images: _imagedata,
                                //speed: -0.2,
                                callBackOnStart: _onStart,
                                callBackOnStop: _onStop,
                                annotations: annotations,
                                annotationOffset: annotationOffset,
                                setup: ''
                            });

                        } catch(e) {
                            _viewer360Img_reel = null;
                        }

                        $annotations = $component.find('.p-annotations .jquery-reel-annotation');

                        if (Modernizr.touch) {
                            $annotations.on('touchstart click', function(){
                                var $elm = $(this);
                                if ($elm.hasClass('p-hover')) {
                                    $(this).toggleClass('p-hover');
                                } else {
                                    $annotations.removeClass('p-hover');
                                    $(this).addClass('p-hover');
                                }
                            });

                            philips.$window.on('touchstart', function(e){
                                if (!$(e.target).parents('.p-annotations')[0]) {
                                    $annotations.removeClass('p-hover');
                                }
                            });

                        } else {
                            $annotations.on('mouseenter', function(){
                                $(this).addClass('p-hover');
                            });

                            $annotations.on('mouseleave', function(){
                                $(this).removeClass('p-hover');
                            });
                        }

                        // callback
                        if( callback ){
                            callback.call();
                        }

                    }, 500);

                    _viewer360Img.unbind('load', loadFirstImage);
                };

                if (philips.isIE) {
                    _viewer360Img.load(_viewer360Img.attr('src'), loadFirstImage);
                } else {
                    _viewer360Img.load(loadFirstImage);
                }
            }
        }

        /**
         *
         * @param hotspots
         * @param annotations
         * @param annotationOffset
         * @private
         */
        function _configureHotspots( hotspots, annotations, annotationOffset ){

            // The zero variables mark the center of the image minus the hotspot width/height. It marks the x:0, y:0, z:0 point of the 3D transforms
            _hotspotHalfWidth = 34 / 2;
            _hotspotHalfHeight = 32 / 2;
            _zeroX = ( _imageWidth / 2 ) - _hotspotHalfWidth;
            _zeroY = ( _imageHeight / 2 ) - _hotspotHalfHeight;

            //Check to make sure hotspots is an array, if not make it one
            if( !(hotspots instanceof Array) ){
                hotspots = [].concat(hotspots);
            }

            // Slight adjustment to hotspots position to bring it inline with the flash
            annotationOffset.x += -25;
            annotationOffset.y += -18;

            for( var i = 0; i < hotspots.length; i++ ){
                annotations['hotspot' + i] = _configureHotspot(hotspots[i], annotationOffset);
            }
        }

        /**
         *
         * @param hotspot
         * @param annotationOffset
         * @returns {*}
         * @private
         */
        function _configureHotspot( hotspot, annotationOffset ) {
            parseHotspot(hotspot);

            // creating node
            hotspotNode = {
                node: {
                    html: '<div class="p-tooltip-360" data-tooltip-video="'+hotspot.video+'"><table><tr><td class="p-tooltext"><span>' +
                        hotspot.defaultLocale.title +
                        '</span></td><td class="p-toolimg"><img src="http://images.philips.com/is/image/PhilipsConsumer/' +
                        hotspot.image + '?wid=118&amp;hei=66&amp;$jpgsmall$" alt="' + hotspot.defaultLocale.title +
                        '" /><div class="p-play-button p-small"><i class="p-icon-play"></i></div></td></tr></table></div>'
                },
                x: 0, y: 0
            };

            // This functionality needs to be tested against other items that have 360view hotspots
            if( hotspot.position && hotspot.position === 'view' ){

                // This is a 2D hotspot
                var xZeroAdjust = -270 - annotationOffset.x, yZeroAdjust = -128 - annotationOffset.y;

                //Set 2D hotspot positions and adjust zero point for non-flash version
                hotspotNode.x = hotspot.x + xZeroAdjust;
                hotspotNode.y = hotspot.y + yZeroAdjust;
                hotspotNode.original_x = hotspot.x + xZeroAdjust;
                hotspotNode.original_y = hotspot.y + yZeroAdjust;

                // Apply hotspot vector multiplier to get final positioning
                hotspotNode.x = _zeroX + (hotspotNode.x * parseInt(hotspot.vectorMultiplier, 10));
                hotspotNode.y = _zeroX + (hotspotNode.y * parseInt(hotspot.vectorMultiplier, 10));

                vec2.subtract(hotspotNode, [hotspotNode.x, hotspotNode.y], [_zeroX, _zeroY]);
                hotspotNode.x3D = 'none';
                hotspotNode.y3D = 'none';
                hotspotNode.z3D = 'none';
            } else {
                // This is a 3D hotspot and will rotate with the product
                // Default properties
                hotspotNode.x = 0;
                hotspotNode.y = 0;
                hotspotNode.hide = [];
                hotspotNode.hidden = false;

                // Apply vector multiplier
                applyVectorMultieplier(hotspot);

                var maxY = (_imageHeight / 2) - _hotspotHalfHeight;

                // If hotspot y is to high move it down
                if( -hotspot.y > maxY ){
                    var tempHotspot = {x: null, y: -maxY, z: null};
                    newXYZFromVect3D(hotspot, tempHotspot);
                    hotspot.x = tempHotspot.x;
                    hotspot.y = tempHotspot.y;
                    hotspot.z = tempHotspot.z;
                }

                // Initialize an empty array of x, y, z coordinates
                var initHotspotsPosition = [];
                for( var i = 0; i < _imagecount; i++ ){
                    initHotspotsPosition[i] = new Vector3D();
                }

                // Poppulate array with rotated coordinates, pass in the starting coordinates and the rest is calculated from there
                // The z-index is reversed because the 3D coordinates were originally written for flash in which the z-axis moves in the opposite direction
                _setInCircleRotate(initHotspotsPosition, 'y', 50, null, {x: hotspot.x, y: hotspot.y, z: -hotspot.z});

                // If using webkit or firefox use 3D translations
                if( Modernizr.csstransforms3d ){

                    hotspotNode.x3D = [];
                    hotspotNode.y3D = [];
                    hotspotNode.z3D = [];

                    hotspotNode.original_x3D = [];
                    hotspotNode.original_y3D = [];
                    hotspotNode.original_z3D = [];

                    // Use calculated to set hotspot animation frame positions
                    for( i = 0; i < initHotspotsPosition.length; i++ ){
                        hotspotNode.x3D.push(initHotspotsPosition[i].x);
                        hotspotNode.original_x3D.push(initHotspotsPosition[i].x);
                        hotspotNode.y3D.push(initHotspotsPosition[i].y);
                        hotspotNode.original_y3D.push(initHotspotsPosition[i].y);
                        hotspotNode.z3D.push(0);
                        hotspotNode.original_z3D.push(0);

                        if( initHotspotsPosition[i].z < 0 ){
                            hotspotNode.hide.push(true);
                        } else {
                            hotspotNode.hide.push(false);
                        }
                    }

                } else {
                    //If IE or another browser Convert 3D position info into 2D coordinates
                    hotspotNode.x = [];
                    hotspotNode.y = [];

                    hotspotNode.original_x = [];
                    hotspotNode.original_y = [];

                    var translatedObj = {}, originalObj = {
                        width: _hotspotHalfWidth * 2,
                        height: _hotspotHalfHeight * 2,
                        x: 0,
                        y: 0
                    };

                    for( i = 0; i < initHotspotsPosition.length; i++ ){

                        // The z-index is reversed because the 3D coordinates were originally written for flash in which the z-axis moves in the opposite direction
                        translate3DTo2D(translatedObj, originalObj, initHotspotsPosition[i]);

                        // rewrite move3D to update properties on translatedObj
                        hotspotNode.x.push(translatedObj.x);
                        hotspotNode.y.push(translatedObj.y);

                        hotspotNode.original_x.push(translatedObj.x);
                        hotspotNode.original_y.push(translatedObj.y);

                        if( initHotspotsPosition[i].z < 0 ){
                            hotspotNode.hide.push(true);
                        } else {
                            hotspotNode.hide.push(false);
                        }
                    }

                    hotspotNode.x3D = 0;
                    hotspotNode.y3D = 0;
                    hotspotNode.z3D = 0;

                }

                setHotspotVisibility(hotspotNode);

                // remove hotspot initialization array from memory
                initHotspotsPosition = null;
            }

            return hotspotNode;
        }

        function parseHotspot(hotspot) {
            if( typeof(hotspot.x) === 'string' ){
                hotspot.x = parseInt(hotspot.x, 10);
            }

            if( typeof(hotspot.y) === 'string' ){
                hotspot.y = parseInt(hotspot.y, 10);
            }

            if( typeof(hotspot.z) === 'string' ){
                hotspot.z = parseInt(hotspot.z, 10);
            }
        }

        function applyVectorMultieplier(hotspot) {
            if( hotspot.x ){
                hotspot.x = hotspot.x * parseInt(hotspot.vectorMultiplier);
            }

            if( hotspot.y ){
                hotspot.y = hotspot.y * parseInt(hotspot.vectorMultiplier);
            }

            if( hotspot.z ){
                hotspot.z = hotspot.z * parseInt(hotspot.vectorMultiplier);
            }
        }

        function addPopUpHandler(hotspot, hotspotNode){
            if( hotspot.video ){

                // Place video hotspots popup code here
                var $bluePrintVideo = $('.blue-print-main li[data-type="video"]', '.p-viewer360-pex-area').find('.popup-video-wrapper');
                var $popupContainer = $('<div class="popup-video-content"/>');
                var videoTitle = '<div class="p-header"><h2 class="p-heading-03">'+hotspot.defaultLocale.title+'</h2></div>';
                var keyRandomNumber = Math.floor((Math.random()*1000000)+1);
                var $videoInstance = {};

                // video popup
                $.magnificPopup.open({
                    items: {
                        src:  $popupContainer,
                        type: 'inline'
                    },
                    key: 'video-key-'+keyRandomNumber,
                    callbacks: {
                        open: function() {
                            var $videoItem = $bluePrintVideo.clone();
                            $popupContainer.append(videoTitle);
                            $popupContainer.append($videoItem);
                            $popupContainer.find('video').attr('data-src', 'PhilipsConsumer/'+hotspot.video+'-AVS').attr('autoplay', true);
                            $popupContainer.find('video').attr('poster', 'PhilipsConsumer/'+hotspot.video+'-AVS');
                            var $videoTarget = $videoItem.find('.p-video');

                            $videoInstance = philips.components.atomic.video.create($videoTarget);
                            $('.mfp-wrap').attr('style','');
                        },
                        beforeClose: function() {
                            $videoInstance.pause();
                            $popupContainer.empty();
                        },
                        close: function() {
                            delete $.magnificPopup.instance.popupsCache['video-key-'+keyRandomNumber];
                        }
                    }
                });
            } else {
                var
                    imageItemWrapper,
                    $imageItem
                ;
                if(hotspot.defaultLocale.text===undefined || hotspot.defaultLocale.text===""){
                    imageItemWrapper = '<div class="popup-image-img"><img src="http://images.philips.com/is/image/PhilipsConsumer/'+
                        hotspot.image + '?wid=300&amp;hei=300&amp;fit=constrain&amp;$jpgsmall$" alt="' + hotspot.defaultLocale.title +
                        '" /></div>';
                } else {
                    imageItemWrapper = '<div class="popup-image-img"><img src="http://images.philips.com/is/image/PhilipsConsumer/'+
                        hotspot.image + '?wid=300&amp;hei=220&amp;fit=constrain&amp;$jpgsmall$" alt="' + hotspot.defaultLocale.title +
                        '" /></div><p>' + hotspot.defaultLocale.text + '</p>';
                }
                $imageItem = '<div class="popup-image-content"><div class="p-header">';
                $imageItem += '<h2 class="p-heading-03">' + hotspot.defaultLocale.title + '</h2>';
                $imageItem += '</div><div class="popup-image-wrapper">' + imageItemWrapper + '</div></div>';

                    $.magnificPopup.open({
                        items: {
                            src:  $imageItem,
                            type: 'inline'
                        },
                        callbacks: {
                            open: function() {
                                $('.mfp-wrap').attr('style','');
                            }
                        }
                    });

            }
        }


        function setHotspotVisibility(hotspotNode) {
            if( hotspotNode.hide[0] ){
                hotspotNode.hidden = true;
            } else {
                hotspotNode.hidden = false;
            }
        }


        /**
         * Accepts an array of elements and a property, for example an elements y position, and
         * sets the property to place the elements in a circle. It also then rotates the element so that
         * its facing away from the circles center.
         * @param {Object} elements
         * @param {Object} prop
         * @param {Object} radius
         * @param {Object} startingAngle
         * @param {Object} startingPoint This point should be reprisented as a vector from the center of the circle, the radius and starting angle will not be used if this is set
         * and instead they will be calculated based on the starting points distance and angle from the center
         *
         * TO DO
         * =====
         *
         * Allow for a starting angle
         * Make get angle from vector function and use instead of getAngleXY
         *
         */
        function _setInCircleRotate( elements, axis, radius, startingAngle, startingPoint ){

            var circleX, circleY, currentAngle, i;

            //Set the angle velocity, this is how many degrees the angle increments each loop
            var angleVel = 360 / (elements.length);

            //Convert angleVel to Radians
            angleVel = angleVel * (Math.PI / 180);

            switch( axis ){
                case 'x':
                    circleX = 'z';
                    circleY = 'y';
                    break;
                case 'y':
                    circleX = 'x';
                    circleY = 'z';
                    break;
                case 'z':
                    circleX = 'x';
                    circleY = 'y';
                    break;
                default:
            }

            if( startingPoint ){
                radius = getMagnitude(startingPoint[circleX], startingPoint[circleY]);
                startingAngle = getAngleXY(0, 0, startingPoint[circleX], startingPoint[circleY]);
            } else {
                startingPoint = {x: 0, y: 0, z: 0};
                startingAngle = 0;
            }

            for( i = 0; i < elements.length; i++ ){
                //Use plus to reverse the movement of the circle
                currentAngle = startingAngle - angleVel * i;
                elements[i][circleX] = Math.round(Math.cos(currentAngle) * radius);
                elements[i][circleY] = Math.round(Math.sin(currentAngle) * radius);
                elements[i][axis] = startingPoint[axis];
            }
        }

        /**
         * Pass a vector and either a new X, Y or Z position and the missing coordinates will be calculated.
         * For example:
         * Passing a vector of [X, Y, Z] and an X of 3 will determine what the Y and Z coordinates are when X is 3.
         *
         * @TechnicalExplanation - The function finds the scale of the change between the new coordinate that has been passed
         * and the matching coordinate from the original vector. It then applies that scaling to each of the other new coordinates
         *
         * To Do
         * =====
         * - Has not been tested yet
         */
        function newXYZFromVect3D( originVect, newVect ){
            var scale = sizes[philips.responsive.getMode()][2];
            if( newVect.x !== null ){
                newVect.y = (originVect.y * scale);
                newVect.z = (originVect.z * scale);
            } else if( newVect.y !== null ){
                newVect.x = (originVect.x * scale);
                newVect.y = (originVect.y * scale);
                newVect.z = (originVect.z * scale);
            } else {
                newVect.x = (originVect.x * scale);
                newVect.y = (originVect.y * scale);
            }
            return newVect;
        }

        function _onStart(){
            show();
            $component.parents('.p-viewer360-pex-area').data('p18PexArea').start360view();
        }

        function _onStop(){
        }

        function _onReset(event, ignoreHide){
            var mode = philips.responsive.mode,
                toMode = philips.responsive.getMode();

            if( !disabled ){
                _options.viewerElement.show();
            }

            _viewer360Img.trigger('frameChange', 1);

            if (!ignoreHide && toMode <= mode.S) {
                $component.parents('.p-viewer360-pex-area').data('p18PexArea').reset360view();
                hide();
            }
        }

        function _onResetCloseView(event, ignoreHide) {
            _viewer360Img.trigger('frameChange', 1);
            if (!ignoreHide) {
                $component.parents('.p-viewer360-pex-area').data('p18PexArea').reset360view();
                hide();
            }
        }

        /**
         * Vector 3D Class
         * @param x
         * @param y
         * @param z
         */
        function Vector3D( x, y, z ){
            this.x = x ? x : 0;
            this.y = y ? y : 0;
            this.z = z ? z : 0;
        }

        /**
         * Pass an object with width, height, x, y & z properties. The function will return a new object
         * with 3D translations applied. The returned object will have width, height, x & y properties.
         *
         * @param translated
         * @param original
         * @param coords
         **/
        function translate3DTo2D( translated, original, coords ){

            //determine how much to scale the objects size and position depending on z position
            //Find the coordinate's angle from the center
            var scale = 1;

            translated.x = (coords.x * scale) + original.x;
            translated.y = (coords.y * scale) + original.y;

            //scale object's size
            translated.width = original.width * scale;
            translated.height = original.height * scale;

            //Translate from the center of the target
            translated.x += (original.width - translated.width) / 2;
            translated.y += (original.height - translated.height) / 2;
        }

        /**
         * Get the length of a vector
         * @param x
         * @param y
         * @returns {number}
         */
        function getMagnitude( x, y ){
            return Math.sqrt((x * x) + (y * y));
        }

        /**
         * Get the angle between two points
         * @param fromX
         * @param fromY
         * @param toX
         * @param toY
         * @returns {number}
         */
        function getAngleXY( fromX, fromY, toX, toY ){
            return(Math.atan2(toY - fromY, toX - fromX));
        }


        /**
         * call custom tracking function
         */
        tracking();

        /**
         * store the instance in jQuery DOM element for later retrieval
         */
        $component.data('viewer360', instance);

        /**
         * push component to components Array instances list
         */
        instances.push(instance);
        /**
         * Tracking is used to track user interaction, add your custom code
         * to track the different user interactions
         *
         * @todo implement your own functionality here
         * @member {Function} tracking
         * @memberOf Viewer360Instance
         * @access private
         * @returns {Mixed}
         */
        function tracking() {
            // put custom tracking code here
        }

        /**
         * Public example method, you can use this for instance to re-render
         * the component
         *
         * @todo implement your own functionality here
         * @member {Function} render
         * @memberOf Viewer360Instance
         * @access public
         * @returns {Mixed}
         */
        function render() {
        }

        /**
         * Returns the instance
         */
        return instance;
    }

    Browser = (function(){

        var document = this.document;
        var window = document.window = this;

        var ua = navigator.userAgent.toLowerCase(),
            platform = navigator.platform.toLowerCase(),
            UA = ua.match(/(opera|ie|firefox|chrome|version)[\s\/:]([\w\d\.]+)?.*?(safari|version[\s\/:]([\w\d\.]+)|$)/) || [null, 'unknown', 0],
            mode = UA[1] === 'ie' && document.documentMode;

        var Browser = {
            name    : (UA[1] === 'version') ? UA[3] : UA[1],
            version : mode || parseFloat((UA[1] === 'opera' && UA[4]) ? UA[4] : UA[2]),
            Platform: {
                name: ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0]
            },
            Features: {
                xpath: !!(document.evaluate),
                air  : !!(window.runtime),
                query: !!(document.querySelector),
                json : !!(window.JSON)
            },
            Support : {}
        };

        Browser[Browser.name] = true;
        Browser[Browser.name + parseInt(Browser.version, 10)] = true;
        Browser.Platform[Browser.Platform.name] = true;

        return Browser;
    })();


    // return the namespace
    return {
        toString: function(){return '[object viewer360]';},
        instances: instances,
        create: create
        // expose other component methods and/or variables
    };
})(jQuery);
/**
 * Viewer360
 *
 * @namespace
 */
philips.libs.viewer360V2 = (function($){
    var
    // description of an exposed property
        /**
         * Collection of component instances
         *
         * @member {Array} instances
         * @memberOf philips.libs.viewer360
         * @access public
         * @see x00ScaffoldInstance
         */
            instances = [],
    // description of a private property
        /**
         * jQuery Collection of component instances
         *
         * @member {Array} $components
         * @memberOf philips.libs.viewer360
         * @access private
         */

            // Static properties
            sizes = [
            'unspecified', // unspecified
            [180, 200, 0.5], // x
            [282, 314, 0.785], // xs
            [296, 329, 0.8225], // m
            [300, 300, 0.8225] // l 
            // previous width for @L : 301.5
        ],

        vec2 = {},

        defaults = {
            hotspots: true,
            debug: true,
            imageurl: '',
            hotspotsurl: '',
            activeAndLoading: true,
            viewerElement: null
        }
        ;

    /**
     * Subtracts two vec2's
     *
     * @param {vec2} out the receiving vector
     * @param {vec2} a the first operand
     * @param {vec2} b the second operand
     * @returns {vec2} out
     */
    vec2.subtract = function( out, a, b ){
        out.x = a[0] - b[0];
        out.y = a[1] - b[1];
        return out;
    };

    // description of an exposed method
    /**
     * Factory method to create a component
     *
     * @memberOf philips.libs.viewer360
     * @access public
     * @param {HTMLElement} component The component HTMLElement
     * @returns {Viewer360Instance} The component instance
     */
    function create(component, options){
        var $component = $(component),

            hotspotData = '',
            imageData = '',

            _imgcount = 0,

            annotations,
            annotationOffset,

            _currentAsset,

            _scaleFactor = 1,
            _imgWidth   = sizes[philips.responsive.getMode()][0],
            _imgHeight  = sizes[philips.responsive.getMode()][1],
            _options    = $.extend(defaults, options || {}), // object
            _imagecount = 72, // number
            _imagedata, // array
            _imagekeys, // array
            _loadeddata = 0, // number
            _loaderdiv = null, // HTMLElement
            _pex = null, // Pex
            _viewer360Img = null, // JQueryElement
            _viewer360MobileTooltipHolder = null, // JQueryElement

            _imageWidth = -1, // number
            _imageHeight = -1, // number

            _viewer360Img_reel = null, // _viewer360Img_reel

            _hotspotHalfWidth = 34 / 2,
            _hotspotHalfHeight = 32 / 2,

            _zeroX = 0,
            _zeroY = 0,

            disabled = false,

            lt_IE9,

            parentInstance  = $component.data().parentInstance,
            parentClass     = $component.data().parentClass,
            closeBtnSXS     = $component.data().popupCloseBtnSXs,

            sourceVideo     = $('script[data-template="p18-360-popup-video"]').html(),

            /**
             * The returned instance. Define the public API here.
             *
             * @member {object} Viewer360Instance
             * @instance
             */
            instance = {
                toString: function(){return '[object viewer360 instance]';},
                component: $component,
                render: render,
                start: _onStart,
                reset: _onReset
                // other possible public component instance methods
            };

        _loaderdiv = $('<p style="padding-top:100px; text-align: center;">' + ($component.attr('data-360-loading-text') || '...') + '</p>');
        _options.viewerElement.append(_loaderdiv);

        _options.viewerElement.append($('<a class="p-close p-viewer-close"><i class="p-square p-icon-close p-small"></i></a>').on('click', _onResetCloseView));

        philips.events.on(philips.responsive.MODE_CHANGE, onModeChange);

        _viewer360Img = $(document.createElement('img')).attr('class', 'viewer360Img');
        _options.viewerElement.append(_viewer360Img);

        _viewer360MobileTooltipHolder = $(document.createElement('div')).addClass('p-viewer360-tooltips');
        _options.viewerElement.append(_viewer360MobileTooltipHolder);

        $.when(
            // Load images
            getViewer360Data(_options.imageurl, 'handler', createUniqueCallbackName(['IS',getImageSetName(_options.imageurl)]), 'imageSet'),

            // load hotspots
            getViewer360Data(_options.hotspotsurl, false, 'hotSpotData', 'hotspots')
        ).then(function () {
            if(hotspotData !== '') {
                hotSpotData(hotspotData);
            }

            if(imageData !== '') {
                s7jsonResponse(imageData);
            }
        }).fail();

        function getImageSetName(url) {
            // Get the name of the image set
            if(url !== '') {
                var pathArray   = url.split('/'),
                    imgName     = pathArray[6].split('?');

                return imgName[0];
            }
        }

        function createUniqueCallbackName (params) {
            // Create a unique cache key based on the url as callback name
            return ('cb' + params.join('')).replace(/-|_/g,'');
        }

        function getViewer360Data(url, handler, callback, type) {
            if(url === '') {
                return;
            }

            return $.ajax({
                url : url,
                dataType : 'jsonp',
                jsonp: handler,
                jsonpCallback: callback,
                cache: true,
                success: function(data) {
                    if(type === 'hotspots') {
                        hotspotData = data || {};
                    } else {
                        imageData = data || [];
                    }
                },
                error: function() {
                }
            });
        }

        function dataIsLoaded(){
            _loadeddata++;

            var totalCounter = (_options.imageurl !== '' && _options.hotspotsurl !== '') ? 2 : _loadeddata;

            if( _loadeddata === totalCounter && _options.activeAndLoading ){
                launch(function(){
                    // trigger mode change for first check.
                    onModeChange(null, null, philips.responsive.getMode());
                });
            }
        }

        /**
         *
         * @param {JQuery.Event} event
         * @param {number} from
         * @param {number} to
         */
        function onModeChange( event, from, to ){

            var mode = philips.responsive.mode;

            if (typeof(from) === 'undefined' || from === null) {
                from = mode.L;
            }

            _scaleFactor = sizes[to][2];
            setSize( sizes[to][0], sizes[to][1] );

            if (from <= mode.S && to >= mode.M) {
                initNormalMode();
            } else if (from >= mode.M && to <= mode.S) {
                initSmallMode();
            }
        }

        function initNormalMode(){
            var annotations = $component.find('.p-annotations .jquery-reel-annotation');
            var $elements = _viewer360MobileTooltipHolder.find('.p-tooltip-360');
            var index;
            _viewer360MobileTooltipHolder.off('.tooltip-mobile');

            $elements.each(function(){
                index = parseInt($(this).attr('data-dom-position'), 10);
                $(this).css('display', 'block');
                $(this).appendTo(annotations[index]);
            });
        }

        function initSmallMode(){

            var annotations = $component.find('.p-annotations .jquery-reel-annotation');

            _options.viewerElement.on('click', function(e){
                if (!$(e.target).hasClass('jquery-reel-annotation') && !$(e.target).parents('.p-tooltip-360')[0]) {
                    _viewer360MobileTooltipHolder.find('.p-tooltip-360').css('display', 'none');
                }
            });

            annotations.each(function( i, el ){
                $(el).off('.tooltip-mobile');

                if (Modernizr.touch) {
                    $(el).on('touchstart.tooltip-mobile', function(){
                        _viewer360MobileTooltipHolder.find('.p-tooltip-360').css('display', 'none');
                        $(_viewer360MobileTooltipHolder.find('.p-tooltip-360')[i]).css('display', 'block');

                    });
                } else {
                    $(el).on('click.tooltip-mobile', function(){
                        _viewer360MobileTooltipHolder.find('.p-tooltip-360').css('display', 'none');
                        $(_viewer360MobileTooltipHolder.find('.p-tooltip-360')[i]).css('display', 'block');

                    });
                }

                var tooltip = $(el).find('.p-tooltip-360');
                tooltip.css('display', 'none');
                tooltip.attr('data-dom-position', i);
                tooltip.appendTo(_viewer360MobileTooltipHolder);
            });

        }

        function setImageData( arr ){
            // Remove any image that does not end in atleast two numbers
            _imagekeys = arr || [];
            _imagedata = [];
            var las2nums = /\d\d$/;

            // returns the last two characters of a string if they are digits
            for( var i = 0; i < _imagekeys.length; i++ ){
                if( _imagekeys[i].match(las2nums) === null ){
                    _imagekeys.splice(i, 1);
                }
            }

            // Sort array alphabetically to ensure that images are in the correct order
            _imagekeys.sort();
        }

        function setSize( width, height ){
            var hotspot;

            if( _viewer360Img_reel ){

                $component.find('.p-annotations').hide();

                _viewer360Img_reel.parent().css({width:width,height:height});
                _viewer360Img_reel.css({width:width,height:height});

                // resize of images on change breakpoint
                if ( _imgWidth !== width || _imgHeight !== height ) {
                    // resize actual visible image
                    var scene7ImageUrl = _viewer360Img_reel.attr('src');
                    scene7ImageUrl = scene7ImageUrl.slice(0, scene7ImageUrl.lastIndexOf("?"));
                    _viewer360Img_reel.attr('src', scene7ImageUrl + '?wid=' + width + '&hei=' + height + '&$jpgsmall$');
                    // resize full imagedata array
                    for( var i = 0; i < _imagecount; i++ ){
                        var scene7ImageUrl
                        = _imagedata[i];
                        scene7ImageUrl = scene7ImageUrl.slice(0, scene7ImageUrl.lastIndexOf("?"));
                        _imagedata[i] = scene7ImageUrl + '?wid=' + width + '&hei=' + height + '&$jpgsmall$';
                    }
                    _imgWidth = width;
                    _imgHeight = height;
                }

                $component.find('.p-annotations').css({
                    left: width/2 + (annotationOffset.x * _scaleFactor),
                    top: height/2 + (annotationOffset.y * _scaleFactor)
                });

                for( var i in annotations ){
                    if( annotations.hasOwnProperty(i) ){
                        hotspot = annotations[i];

                        if(typeof(hotspot.original_x) !== 'undefined' && typeof(hotspot.original_x.length) !== 'undefined'){
                            for( var j = 0; j < hotspot.original_x.length; j++ ){
                                hotspot.x[j] = hotspot.original_x[j] * _scaleFactor;
                                hotspot.y[j] = hotspot.original_y[j] * _scaleFactor;
                            }
                        } else if(typeof(hotspot.x3D) !== 'string'){
                            for( var k = 0; k < hotspot.original_x3D.length; k++ ){
                                hotspot.x3D[k] = hotspot.original_x3D[k] * _scaleFactor;
                                hotspot.y3D[k] = hotspot.original_y3D[k] * _scaleFactor;
                                hotspot.z3D[k] = hotspot.original_z3D[k] * _scaleFactor;
                            }
                        } else {
                            hotspot.x = hotspot.original_x * _scaleFactor;
                            hotspot.y = hotspot.original_y * _scaleFactor;
                        }
                    }
                }

                setTimeout(function(){
                    $component.find('.p-annotations').show();

                    _onReset(null, true);
                }, 200);
            }

        }

        function s7jsonResponse( json ) {
            // Break Image data into array
            setImageData(json.IMAGE_SET.split(','));
            // Add image extension
            for( var i = 0; i < _imagekeys.length; i++ ){
                //".jpg" // set .jpg for testing purpose
                _imagedata.push('http://images.philips.com/is/image/' + _imagekeys[i] + '?wid=' + _imgWidth + '&hei=' + _imgHeight + '&$jpgsmall$');
            }

            //Set image count and base image URL
            _imagecount = _imagekeys.length;

            // Clear still loading info
            _loaderdiv.remove();

            _options.viewerElement.find('.viewer360Img').css('display', 'block');

            dataIsLoaded();
        }

        function hotSpotData( json ){
            _pex = json.pex;
            dataIsLoaded();
        }

        function show() {
            $component.css({ 'opacity': '1' });
            $component.parents(parentClass).data(parentInstance).showReset();
        }

        function hide(){
            $component.css({ 'opacity': '0' });
            $component.parents(parentClass).data(parentInstance).hideReset();
        }

        function launch( callback ){
            if( _options.imageurl !== _currentAsset ){

                if( typeof _options.viewerElement === "undefined" || _options.viewerElement === null ){
                    return;
                }

                hide();

                // On P3D launch. Check if image data was returned
                if( _imagedata === null ){
                    // If not set activeAndLoading to true
                    _options.activeAndLoading = true;
                    // Display data still loading
                    return;
                }
                // Otherwise imageData is loaded and 360 can be displayed

                // Set flag for if browser is IE and version is less than 9
                if( philips.isIE8 ){
                    lt_IE9 = true;
                } else {
                    lt_IE9 = false;
                }

                if(_imagedata) {
                    _viewer360Img.attr("src", _imagedata[0] );
                } else {
                    _viewer360Img.attr("src", $component.parents(parentClass).find('.p-normal-view img')[0].src );
                }

                // Once the base image is loaded, initialize the viewer360 reel
                // The reel() plugin will load in the rest of the image sequence.
                _options.viewerElement.addClass('p-load-image');

                var loadFirstImage = function() {
                    setTimeout(function(){
                        _options.viewerElement.removeClass('p-load-image');

                        //Set Image width and height
                        _imageWidth = parseInt(_viewer360Img[0].width, 10);
                        _imageHeight = parseInt(_viewer360Img[0].height, 10);

                        //Convert hotspot data to annotations object for jQuery reel
                        annotations = {};
                        var hotspots = [];

                        annotationOffset = {x: 0, y: 0};

                        // Items without an fov of 70 will have the hotspots ignored
                        if( _pex !== null && _pex.views.Explore.content && _pex.views.Explore.content.Hotspot && _options.hotspots ){
                            hotspots = _pex.views.Explore.content.Hotspot;

                            annotationOffset.x = parseInt(_pex.views.Explore.content.offsetX, 10);
                            annotationOffset.y = parseInt(_pex.views.Explore.content.offsetY, 10);

                            _configureHotspots(hotspots, annotations, annotationOffset);
                        }

                        try {
                            $component.parents(parentClass).data(parentInstance).loaded360view();
                            _viewer360Img_reel = _viewer360Img.reel({
                                _wrapper: $component,
                                frames: _imgcount,
                                saves: true,
                                images: _imagedata,
                                //speed: -0.2,
                                callBackOnStart: _onStart,
                                callBackOnStop: _onStop,
                                annotations: annotations,
                                annotationOffset: annotationOffset,
                                setup: ''
                            });

                        } catch(e) {
                            _viewer360Img_reel = null;
                        }

                        $annotations = $component.find('.p-annotations .jquery-reel-annotation');
                        $annotations.addClass('p-square p-icon-plus');

                      
                            $annotations.on('mouseenter', function(){
                                $(this).addClass('p-hover');
                            });

                            $annotations.on('mouseleave', function(){
                                $(this).removeClass('p-hover');
                            });
                        

                        // callback
                        if( callback ){
                            callback.call();
                        }

                    }, 500);

                    _viewer360Img.unbind('load', loadFirstImage);
                };

                if (philips.isIE) {
                    _viewer360Img.load(_viewer360Img.attr('src'), loadFirstImage);
                } else {
                    _viewer360Img.load(loadFirstImage);
                }
            }
        }

        /**
         *
         * @param hotspots
         * @param annotations
         * @param annotationOffset
         * @private
         */
        function _configureHotspots( hotspots, annotations, annotationOffset ){

            // The zero variables mark the center of the image minus the hotspot width/height. It marks the x:0, y:0, z:0 point of the 3D transforms
            _hotspotHalfWidth = 34 / 2;
            _hotspotHalfHeight = 32 / 2;
            _zeroX = ( _imageWidth / 2 ) - _hotspotHalfWidth;
            _zeroY = ( _imageHeight / 2 ) - _hotspotHalfHeight;

            //Check to make sure hotspots is an array, if not make it one
            if( !(hotspots instanceof Array) ){
                hotspots = [].concat(hotspots);
            }

            // Slight adjustment to hotspots position to bring it inline with the flash
            annotationOffset.x += -25;
            annotationOffset.y += -18;

            var randomNumber = Math.floor((Math.random() * 1000) + 1);
            for( var i = 0; i < hotspots.length; i++ ){
                annotations['hotspot' + i + '' + randomNumber] = _configureHotspot(hotspots[i], annotationOffset);
            }
        }

        /**
         *
         * @param hotspot
         * @param annotationOffset
         * @returns {*}
         * @private
         */
        function _configureHotspot( hotspot, annotationOffset ) {
            parseHotspot(hotspot);

            // creating node
            if (hotspot.video) {
                playButtonMarkup = '<div class="p-play-button p-small"><i class="p-icon-play"></i></div>';
            } else {
                playButtonMarkup = '';
            }

            hotspotNode = {
                node: {
                    html: '<div class="p-tooltip-360"><table><tr><td class="p-tooltext"><span>' +
                        hotspot.defaultLocale.title +
                        '</span></td><td class="p-toolimg"><img src="http://images.philips.com/is/image/PhilipsConsumer/' +
                        hotspot.image + '?wid=118&amp;hei=66&amp;$jpgsmall$" alt="' + hotspot.defaultLocale.title +
                        '" />' + playButtonMarkup + '</td></tr></table></div>'
                },
                x: 0, y: 0
            };

            // Popup functionality for the hotspots
            addPopUpHandler(hotspot, hotspotNode);

            // This functionality needs to be tested against other items that have 360view hotspots
            if( hotspot.position && hotspot.position === 'view' ){

                // This is a 2D hotspot
                var xZeroAdjust = -270 - annotationOffset.x, yZeroAdjust = -128 - annotationOffset.y;

                //Set 2D hotspot positions and adjust zero point for non-flash version
                hotspotNode.x = hotspot.x + xZeroAdjust;
                hotspotNode.y = hotspot.y + yZeroAdjust;
                hotspotNode.original_x = hotspot.x + xZeroAdjust;
                hotspotNode.original_y = hotspot.y + yZeroAdjust;

                // Apply hotspot vector multiplier to get final positioning
                hotspotNode.x = _zeroX + (hotspotNode.x * parseInt(hotspot.vectorMultiplier, 10));
                hotspotNode.y = _zeroX + (hotspotNode.y * parseInt(hotspot.vectorMultiplier, 10));

                vec2.subtract(hotspotNode, [hotspotNode.x, hotspotNode.y], [_zeroX, _zeroY]);
                hotspotNode.x3D = 'none';
                hotspotNode.y3D = 'none';
                hotspotNode.z3D = 'none';
            } else {
                // This is a 3D hotspot and will rotate with the product
                // Default properties
                hotspotNode.x = 0;
                hotspotNode.y = 0;
                hotspotNode.hide = [];
                hotspotNode.hidden = false;

                // Apply vector multiplier
                applyVectorMultieplier(hotspot);

                var maxY = (_imageHeight / 2) - _hotspotHalfHeight;

                // If hotspot y is to high move it down
                if( -hotspot.y > maxY ){
                    var tempHotspot = {x: null, y: -maxY, z: null};
                    newXYZFromVect3D(hotspot, tempHotspot);
                    hotspot.x = tempHotspot.x;
                    hotspot.y = tempHotspot.y;
                    hotspot.z = tempHotspot.z;
                }

                // Initialize an empty array of x, y, z coordinates
                var initHotspotsPosition = [];
                for( var i = 0; i < _imagecount; i++ ){
                    initHotspotsPosition[i] = new Vector3D();
                }

                // Poppulate array with rotated coordinates, pass in the starting coordinates and the rest is calculated from there
                // The z-index is reversed because the 3D coordinates were originally written for flash in which the z-axis moves in the opposite direction
                _setInCircleRotate(initHotspotsPosition, 'y', 50, null, {x: hotspot.x, y: hotspot.y, z: -hotspot.z});

                // If using webkit or firefox use 3D translations
                if( Modernizr.csstransforms3d ){

                    hotspotNode.x3D = [];
                    hotspotNode.y3D = [];
                    hotspotNode.z3D = [];

                    hotspotNode.original_x3D = [];
                    hotspotNode.original_y3D = [];
                    hotspotNode.original_z3D = [];

                    // Use calculated to set hotspot animation frame positions
                    for( i = 0; i < initHotspotsPosition.length; i++ ){
                        hotspotNode.x3D.push(initHotspotsPosition[i].x);
                        hotspotNode.original_x3D.push(initHotspotsPosition[i].x);
                        hotspotNode.y3D.push(initHotspotsPosition[i].y);
                        hotspotNode.original_y3D.push(initHotspotsPosition[i].y);
                        hotspotNode.z3D.push(0);
                        hotspotNode.original_z3D.push(0);

                        if( initHotspotsPosition[i].z < 0 ){
                            hotspotNode.hide.push(true);
                        } else {
                            hotspotNode.hide.push(false);
                        }
                    }

                } else {
                    //If IE or another browser Convert 3D position info into 2D coordinates
                    hotspotNode.x = [];
                    hotspotNode.y = [];

                    hotspotNode.original_x = [];
                    hotspotNode.original_y = [];

                    var translatedObj = {}, originalObj = {
                        width: _hotspotHalfWidth * 2,
                        height: _hotspotHalfHeight * 2,
                        x: 0,
                        y: 0
                    };

                    for( i = 0; i < initHotspotsPosition.length; i++ ){

                        // The z-index is reversed because the 3D coordinates were originally written for flash in which the z-axis moves in the opposite direction
                        translate3DTo2D(translatedObj, originalObj, initHotspotsPosition[i]);

                        // rewrite move3D to update properties on translatedObj
                        hotspotNode.x.push(translatedObj.x);
                        hotspotNode.y.push(translatedObj.y);

                        hotspotNode.original_x.push(translatedObj.x);
                        hotspotNode.original_y.push(translatedObj.y);

                        if( initHotspotsPosition[i].z < 0 ){
                            hotspotNode.hide.push(true);
                        } else {
                            hotspotNode.hide.push(false);
                        }
                    }

                    hotspotNode.x3D = 0;
                    hotspotNode.y3D = 0;
                    hotspotNode.z3D = 0;

                }

                setHotspotVisibility(hotspotNode);

                // remove hotspot initialization array from memory
                initHotspotsPosition = null;
            }

            return hotspotNode;
        }

        function parseHotspot(hotspot) {
            if( typeof(hotspot.x) === 'string' ){
                hotspot.x = parseInt(hotspot.x, 10);
            }

            if( typeof(hotspot.y) === 'string' ){
                hotspot.y = parseInt(hotspot.y, 10);
            }

            if( typeof(hotspot.z) === 'string' ){
                hotspot.z = parseInt(hotspot.z, 10);
            }
        }

        function applyVectorMultieplier(hotspot) {
            if( hotspot.x ){
                hotspot.x = hotspot.x * parseInt(hotspot.vectorMultiplier);
            }

            if( hotspot.y ){
                hotspot.y = hotspot.y * parseInt(hotspot.vectorMultiplier);
            }

            if( hotspot.z ){
                hotspot.z = hotspot.z * parseInt(hotspot.vectorMultiplier);
            }
        }

        function addPopUpHandler(hotspot, hotspotNode){
            // Popup vars
            var keyRandomNumber = Math.floor((Math.random()*1000000)+1);
            var closeMarkUpBtn = [
                              '<div class="mfp-close p-popup-close">',
                                  '<i class="mfp-close p-square p-icon-close p-small"></i>',
                              '</div>',
                              '<div class="mfp-close p-popup-back">',
                                  '<span class="mfp-close">'+closeBtnSXS+'</span>',
                              '</div>'
                              ];
            var closeBtn = closeMarkUpBtn.join('');

            if( hotspot.video ) {
                // *****************************************************
                // work in progress...
                // *****************************************************
                hotspotNode.onclick = function(){
                    // Place video hotspots popup code here
                    var popupContainer =    [
                                             '<div class="p-popup">',
                                                 '<div class="p-popup-content">',
                                                     '<div class="p-popup-content-wrapper p-popup-video-content">',
                                                         '<section></section>',
                                                     '</div>',
                                                 '</div>',
                                             '</div>'
                                             ];
                    var $popupContainer = $(popupContainer.join(''));
                    var videoTitle =    [
                                        '<div class="p-header">',
                                            '<h2 class="p-heading-03">',
                                                hotspot.defaultLocale.title,
                                            '</h2>',
                                        '</div>'
                                        ];
                    $popupContainer.find('section').append(videoTitle.join(''));
                    var popupContent =  [
                                        '<div class="p-scrollable-content">',
                                            '<div class="p-wrapper">',
                                                '<div class="p-video-wrapper">',
                                                '</div>',
                                            '</div>',
                                        '</div>'
                                        ];
                    $popupContainer.find('section').append(popupContent.join(''));
                    var context = {'videosrc': hotspot.video, 'imgsrc': hotspot.image};
                    // Scene7 video template
                    $popupContainer.find('.p-video-wrapper').append($videoItem);
                    //
                    var $videoInstance = {};

                    $.magnificPopup.open({
                        items: {
                            src:  $popupContainer,
                            type: 'inline'
                        },
                        key: 'video-key-'+keyRandomNumber,
                        mainClass: 'p-popup-sky',
                        closeMarkup: closeBtn,
                        midClick: true,
                        callbacks: {
                            open: function() {
                                var $videoTarget = $popupContainer.find('.p-video');
    
                                $videoInstance = philips.components.atomic.videoV2.create($videoTarget);
                                $('.mfp-wrap').attr('style','');
                            },
                            beforeClose: function() {
                                $videoInstance.pause();
                                $popupContainer.empty();
                            },
                            close: function() {
                                delete $.magnificPopup.instance.popupsCache['video-key-'+keyRandomNumber];
                            }
                        }
                    });
                };

                //hotspotNode.onclick = function(){
                    //$('.p-popup-wrapper').data('popup').openPopup(null, 'p-pop06-video-fragment');
                //};

            } else {
                hotspotNode.onclick = function(){
                    // Place image hotspots popup code here
                    var popupContainer =    [
                                             '<div class="p-popup p-popup-narrow">',
                                                 '<div class="p-popup-content">',
                                                     '<div class="p-popup-content-wrapper">',
                                                         '<section></section>',
                                                     '</div>',
                                                 '</div>',
                                             '</div>'
                                             ];
                    var $popupContainer = $(popupContainer.join(''));
                    var videoTitle =    [
                                        '<div class="p-header">',
                                            '<h2 class="p-heading-03">',
                                                hotspot.defaultLocale.title,
                                            '</h2>',
                                        '</div>'
                                        ];
                    $popupContainer.find('section').append(videoTitle.join(''));
                    var popupContent =  [
                                        '<div class="p-scrollable-content">',
                                            '<div class="p-wrapper">',
                                                '<div class="p-image-wrapper">',
                                                '</div>',
                                            '</div>',
                                        '</div>'
                                        ];
                    $popupContainer.find('section').append(popupContent.join(''));
                    //
                    if (hotspot.image !== undefined && hotspot.image !== "") {
                        var imageItem = [
                                     '<div class="popup-image-img">',
                                         '<img src="http://images.philips.com/is/image/PhilipsConsumer/',
                                             hotspot.image,
                                             '?wid=300&amp;hei=255&amp;fit=constrain&amp;$jpgsmall$" ',
                                             'alt="' + hotspot.defaultLocale.title + '" />',
                                     '</div>'
                                     ];
                        $popupContainer.find('.p-image-wrapper').append(imageItem.join(''));
                    }
                    if (hotspot.defaultLocale.text !== undefined && hotspot.defaultLocale.text !== "") {
                        var textItem = '<p>' + hotspot.defaultLocale.text + '</p>';
                        $popupContainer.find('.p-image-wrapper').append(textItem);
                    }

                    $.magnificPopup.open({
                        items: {
                            src:  $popupContainer,
                            type: 'inline'
                        },
                        key: 'image-key-'+keyRandomNumber,
                        mainClass: 'p-popup-sky',
                        closeMarkup: closeBtn,
                        midClick: true,
                        callbacks: {
                            open: function() {
                                $('.mfp-wrap').attr('style','');
                            },
                            beforeClose: function() {
                                $popupContainer.empty();
                            },
                            close: function() {
                                delete $.magnificPopup.instance.popupsCache['image-key-'+keyRandomNumber];
                            }
                        }
                    });

                };
            }
        }

        function setHotspotVisibility(hotspotNode) {
            if( hotspotNode.hide[0] ){
                hotspotNode.hidden = true;
            } else {
                hotspotNode.hidden = false;
            }
        }

        /**
         * Accepts an array of elements and a property, for example an elements y position, and
         * sets the property to place the elements in a circle. It also then rotates the element so that
         * its facing away from the circles center.
         * @param {Object} elements
         * @param {Object} prop
         * @param {Object} radius
         * @param {Object} startingAngle
         * @param {Object} startingPoint This point should be reprisented as a vector from the center of the circle, the radius and starting angle will not be used if this is set
         * and instead they will be calculated based on the starting points distance and angle from the center
         *
         * TO DO
         * =====
         *
         * Allow for a starting angle
         * Make get angle from vector function and use instead of getAngleXY
         *
         */
        function _setInCircleRotate( elements, axis, radius, startingAngle, startingPoint ){

            var circleX, circleY, currentAngle, i;

            //Set the angle velocity, this is how many degrees the angle increments each loop
            var angleVel = 360 / (elements.length);

            //Convert angleVel to Radians
            angleVel = angleVel * (Math.PI / 180);

            switch( axis ){
                case 'x':
                    circleX = 'z';
                    circleY = 'y';
                    break;
                case 'y':
                    circleX = 'x';
                    circleY = 'z';
                    break;
                case 'z':
                    circleX = 'x';
                    circleY = 'y';
                    break;
                default:
            }

            if( startingPoint ){
                radius = getMagnitude(startingPoint[circleX], startingPoint[circleY]);
                startingAngle = getAngleXY(0, 0, startingPoint[circleX], startingPoint[circleY]);
            } else {
                startingPoint = {x: 0, y: 0, z: 0};
                startingAngle = 0;
            }

            for( i = 0; i < elements.length; i++ ){
                //Use plus to reverse the movement of the circle
                currentAngle = startingAngle - angleVel * i;
                elements[i][circleX] = Math.round(Math.cos(currentAngle) * radius);
                elements[i][circleY] = Math.round(Math.sin(currentAngle) * radius);
                elements[i][axis] = startingPoint[axis];
            }
        }

        /**
         * Pass a vector and either a new X, Y or Z position and the missing coordinates will be calculated.
         * For example:
         * Passing a vector of [X, Y, Z] and an X of 3 will determine what the Y and Z coordinates are when X is 3.
         *
         * @TechnicalExplanation - The function finds the scale of the change between the new coordinate that has been passed
         * and the matching coordinate from the original vector. It then applies that scaling to each of the other new coordinates
         *
         * To Do
         * =====
         * - Has not been tested yet
         */
        function newXYZFromVect3D( originVect, newVect ){
            var scale = sizes[philips.responsive.getMode()][2];
            if( newVect.x !== null ){
                newVect.y = (originVect.y * scale);
                newVect.z = (originVect.z * scale);
            } else if( newVect.y !== null ){
                newVect.x = (originVect.x * scale);
                newVect.y = (originVect.y * scale);
                newVect.z = (originVect.z * scale);
            } else {
                newVect.x = (originVect.x * scale);
                newVect.y = (originVect.y * scale);
            }
            return newVect;
        }

        function _onStart(){
            show();
            $component.parents(parentClass).data(parentInstance).start360view();
        }

        function _onStop(){
        }

        function _onReset(event, ignoreHide){
            var mode = philips.responsive.mode,
                toMode = philips.responsive.getMode();

            if( !disabled ){
                _options.viewerElement.show();
            }

            _viewer360Img.trigger('frameChange', 1);

            if (!ignoreHide && toMode <= mode.S) {
                $component.parents(parentClass).data(parentInstance).reset360view();
                hide();
            }
        }

        function _onResetCloseView(event, ignoreHide) {
            _viewer360Img.trigger('frameChange', 1);
            if (!ignoreHide) {
                $component.parents(parentClass).data(parentInstance).reset360view();
                hide();
            }
        }

        /**
         * Vector 3D Class
         * @param x
         * @param y
         * @param z
         */
        function Vector3D( x, y, z ){
            this.x = x ? x : 0;
            this.y = y ? y : 0;
            this.z = z ? z : 0;
        }

        /**
         * Pass an object with width, height, x, y & z properties. The function will return a new object
         * with 3D translations applied. The returned object will have width, height, x & y properties.
         *
         * @param translated
         * @param original
         * @param coords
         **/
        function translate3DTo2D( translated, original, coords ){

            //determine how much to scale the objects size and position depending on z position
            //Find the coordinate's angle from the center
            var scale = 1;

            translated.x = (coords.x * scale) + original.x;
            translated.y = (coords.y * scale) + original.y;

            //scale object's size
            translated.width = original.width * scale;
            translated.height = original.height * scale;

            //Translate from the center of the target
            translated.x += (original.width - translated.width) / 2;
            translated.y += (original.height - translated.height) / 2;
        }

        /**
         * Get the length of a vector
         * @param x
         * @param y
         * @returns {number}
         */
        function getMagnitude( x, y ){
            return Math.sqrt((x * x) + (y * y));
        }

        /**
         * Get the angle between two points
         * @param fromX
         * @param fromY
         * @param toX
         * @param toY
         * @returns {number}
         */
        function getAngleXY( fromX, fromY, toX, toY ){
            return(Math.atan2(toY - fromY, toX - fromX));
        }


        /**
         * call custom tracking function
         */
        tracking();

        /**
         * store the instance in jQuery DOM element for later retrieval
         */
        $component.data('viewer360', instance);

        /**
         * push component to components Array instances list
         */
        instances.push(instance);
        /**
         * Tracking is used to track user interaction, add your custom code
         * to track the different user interactions
         *
         * @todo implement your own functionality here
         * @member {Function} tracking
         * @memberOf Viewer360Instance
         * @access private
         * @returns {Mixed}
         */
        function tracking() {
            // put custom tracking code here
        }

        /**
         * Public example method, you can use this for instance to re-render
         * the component
         *
         * @todo implement your own functionality here
         * @member {Function} render
         * @memberOf Viewer360Instance
         * @access public
         * @returns {Mixed}
         */
        function render() {
        }

        /**
         * Returns the instance
         */
        return instance;
    }

    Browser = (function(){

        var document = this.document;
        var window = document.window = this;

        var ua = navigator.userAgent.toLowerCase(),
            platform = navigator.platform.toLowerCase(),
            UA = ua.match(/(opera|ie|firefox|chrome|version)[\s\/:]([\w\d\.]+)?.*?(safari|version[\s\/:]([\w\d\.]+)|$)/) || [null, 'unknown', 0],
            mode = UA[1] === 'ie' && document.documentMode;

        var Browser = {
            name    : (UA[1] === 'version') ? UA[3] : UA[1],
            version : mode || parseFloat((UA[1] === 'opera' && UA[4]) ? UA[4] : UA[2]),
            Platform: {
                name: ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0]
            },
            Features: {
                xpath: !!(document.evaluate),
                air  : !!(window.runtime),
                query: !!(document.querySelector),
                json : !!(window.JSON)
            },
            Support : {}
        };

        Browser[Browser.name] = true;
        Browser[Browser.name + parseInt(Browser.version, 10)] = true;
        Browser.Platform[Browser.Platform.name] = true;

        return Browser;
    })();


    // return the namespace
    return {
        toString: function(){return '[object viewer360]';},
        instances: instances,
        create: create
        // expose other component methods and/or variables
    };
})(jQuery);

/** @namespace */
window.philips.components = window.philips.components || {};
/** @namespace */
window.philips.components.aggregated = window.philips.components.aggregated || {};
/** @namespace */
philips.components.atomic = {
    toString: function(){return '[object atomic]';}
};

philips.components.init = (function($) {

    var callbacks = {
        before: [],
        after: []
    };

    function initialize(el, render) {
        var $el = $(el);
        var $components = $el.find('[data-comp-id]').addBack('[data-comp-id]');

        fireCallbacks($el, callbacks.before);

        $.each($components.get().reverse(), function() {
            var compId = $(this).data('comp-id');

            if (render) {
                var cmp = $(this).data(compId);
                if (typeof cmp !== "undefined" && cmp.render) {
                    cmp.render();
                }
            } else if (philips.components.aggregated[compId]) {
                philips.components.aggregated[compId].create(this);
            }
        });

        fireCallbacks($el, callbacks.after);
    }

    function fireCallbacks($el, callbacks) {
        $.each(callbacks, function(idx, fn) {
            try {
                fn($el);
            } catch (e) {
                console.log(e);
            }
        });
    }

    return {
        initialize: initialize,
        callbacks: callbacks
    };

})(jQuery);
philips.components.init.callbacks.before.push(function($el) {

    if ($el.find('span[data-picture]').length) {
        window.picturefill($el.get(0));
    }

});

/**
 * P_18v2 PEX Area
 * Namespace with a factory creating component instances on document.ready
 *
 * @namespace
 */
philips.components.aggregated.p18v2PexArea = (function($){
    var
        /**
         * Collection of component instances.
         *
         * @member {Array} instances
         * @memberOf philips.components.aggregated.p18v2PexArea
         * @access public
         * @see p18v2PexAreaInstance
         */
        instances = [],
        // jQuery collection of component instances.
        $components,
        // Cache needed namespace objects.
        events = philips.events,
        responsive = philips.responsive,
        mode = responsive.mode,
        easing = philips.utilities.getEasing,
        preloadImages = philips.utilities.preloadImages,
        loadedImages = [],
        viewer360 = philips.libs.viewer360V2,
        currentMode
    ;

    if($){
        // Initialise components on document ready.
        $(function(){
        	$check360 = $(".s7spinner-image");
        	if($check360.length > 0){
        		var imgURL = $check360.find("img").eq(0).attr("data-primaryimagesrc");
        		var imgURL = imgURL.replace("https:","").replace("http:","");
        		var thumpImage = imgURL+"?wid=300&amp;hei=255&amp;$pnglarge$";
        		var spinnerImage = imgURL+"?req=imageset,json";
        		$(".p-p18v2-pex-area .p-normal-view img").attr("src",thumpImage);
        		$(".p-p18v2-pex-area .p-360-viewer").attr("data-img",spinnerImage);
        		$components = $('.p-p18v2-pex-area');
                $components.each(function () {
                    create(this);
                });
        	}
            
        });
    }

    /**
     * Factory method to create a component
     *
     * @memberOf philips.components.aggregated.p18PexArea
     * @access public
     * @param {HTMLElement} component The component HTMLElement
     * @returns {p18PexAreaInstance} The component instance
     */
    function create(component){
        var $component = $(component),

            galleryRendered     = false,
            videoRendered       = false,

        // Tween Durations
            defaultSlideDuration = 400,
            defaultZoomDuration = 350,

            videos = [],

            tweenEnabled = true,

        // Zoom Variables
            zoomEnabled = true,
            zoomLevel = 0,

       // Scroll the component to focus the pex image
            scrollTo = $component.offset().top,

            $curZoomWrapper,
            $zoomWrapper = $component.find('.p-zoom-wrapper'),

        // Main Items Slider
            currentCategory = 'packshot',
            currentActive = 0,

            $pexLinks = null,
            $mainItems = null,

            $viewer360Holder = null,

            $rating           = $component.find('.p-rating'),

        // PackShot Elements
            $productInfo      = null,
            $productPriceInfo = null,

        // Mobile Nav and Category Items
            $mobileCategoryLinks = $component.find('.p-s-categories a'),

            $smallSliderNav     = $component.find('.p-s-slider-nav'),
            $smallSliderNavPrev = $smallSliderNav.find('.p-nav-prev'),
            $smallSliderNavNext = $smallSliderNav.find('.p-nav-next'),
            $smallSliderNumbers = $component.find('.p-gallery-numbers'),

        // Main Navigation Elements
            $mainClose     = $component.find('.p-close'),
            $downloadImage = $component.find('.p-download-image'),

            $resetSmallButton = $component.find('.p-s-reset-button'),

        // Nav Slider Elements
            $navSliderItems = $component.find('.p-slider-item'),
            thumbstrip,

            viewer360Instance,

            /**
             * p18PexArea instance.
             * @namespace p18PexAreaInstance
             * @see philips.components.aggregated.p18PexArea
             * @instance
             */
            instance = {
                toString: function(){return '[object P_18 Pex Area instance]';},
                component:      $component,
                render:         render,
                renderVideo:    renderVideo,
                start360view:   start360view,
                reset360view:   reset360view,
                loaded360view:  loaded360view,
                showReset:      showReset,
                hideReset:      hideReset
                // other possible public component instance methods
            }
        ;

        $('.p-render-gallery-button').on('click', function() {
            $navSliderItems = $component.find('.p-slider-item');
            render();
            addEvents();
        });

        $('.p-render-video-button').on('click', function() {
            renderVideo();
        });

      /**
         * Public method to show the 360 reset button
         *
         * @method showReset
         * @access private
         */
        function showReset() {
            $viewer360Reset.css('display', 'block');
        }
        /**
         * Public method to hide the 360 reset button
         *
         * @method hideReset
         * @access private
         */
        function hideReset() {
            $viewer360Reset.css('display', 'none');
        }

        /**
         * Set the elements
         *
         * @method setElements
         * @access private
         */
        function setElements(){

            $pexLinks = $component.find('.p-pex-link');
            $mainItems = $component.find('.p-viewer > li');

            $viewer360Holder = $component.find('.p-360-viewer');

            // PackShot Elements
            $productInfo = $component.find('.p-product-info');
            $productPriceInfo = $component.find('.p-price-info-wrapper');

            $viewer360Reset = $component.find('.p-reset-button');
        }


            setElements();
            addPexLinks();
            addZoomEvents();
            initCurrentSlideVideo();
            initCurrentSlide();

            hide360Btn();

            addEvents();
            init360();

        /**
         * Add the behaviors for the elements
         *
         * @method addEvents
         * @access private
         */
        function addEvents() {
            

            $component.find('.p-zoom-in, .p-zoom-out').on('click', onZoomClick);

            $smallSliderNavPrev.on('click', prevSliderItem);
            $smallSliderNavNext.on('click', nextSliderItem);

            $resetSmallButton.on('click', function(){
                onPexClick({ currentTarget: $mainClose[0] });
            });

            events.on(responsive.MODE_CHANGE, handleModeChange);
            events.on(events.RESIZE, handleResize);

            handleModeChange(null, null, philips.responsive.getMode());

            setAttrDownloadButton();

        }

        /**
         * Handles the resize
         *
         * - Check the review link height
         * - Center the current slider after resizing
         *
         * @method handleResize
         * @access private
         */
        function handleResize() {
            checkReviewLinksHeight();
            adjustNavButtonForCaption();
        }

        /**
         * Add a multiline class for wrapping the review links
         *
         * @method checkReviewLinksHeight
         * @access private
         */
        function checkReviewLinksHeight() {
            var ratingWrapper = $component.find('.p-rating').removeClass('p-multiline'),
                $reviewsWrapper = $component.find('.p-reviews'),
                $reviewsLinks = $reviewsWrapper.find('> li'),
                wrapperHeight = $reviewsWrapper.height(),
                itemHeight = $reviewsLinks.height();

            if (wrapperHeight > itemHeight) {
                ratingWrapper.addClass('p-multiline');
            }
        }

        /**
         * This handles the caroussel swipe
         *
         * @method handleViewerSwipe
         * @access private
         * @param {Event} event
         */
        function handleViewerSwipe(event){
            if (currentCategory === '360') {
                return;
            }
            var gesture = event.gesture;
            if( gesture ) {
                switch (gesture.direction) {
                    case 'left':
                        nextSliderItem();
                        break;
                    case 'right':
                        prevSliderItem();
                        break;
                    default: break;
                }
            }
        }

        /**
         * Handles the image zoom click
         *
         * @method onZoomClick
         * @access private
         * @param {Event} event
         */
        function onZoomClick(event) {
            event.preventDefault();
            $curZoomWrapper = $($mainItems[currentActive]);
            if ($(event.currentTarget).hasClass('p-zoom-out') && currentCategory === 'image') {
                $component.removeClass('p-zoomed-full');
                zoomBack();
                $smallSliderNav.addClass('p-show');
            } else if($(event.currentTarget).hasClass('p-zoom-out')) {
                $component.removeClass('p-zoomed-full');
                zoomBack();
                $smallSliderNav.removeClass('p-show');
            }else{
                zoom();
                $smallSliderNav.removeClass('p-show');
            }
        }

        /**
         * Show the previous slider item
         *
         * @method prevSliderItem
         * @access private
         * @param {Event} event
         */
        function prevSliderItem(event) {
            if (event) {
                event.preventDefault();
            }

            var $sliderItem = $navSliderItems.find('.p-active').parents('.p-slider-item'),
                $button = $sliderItem.prev().find('a');

            if (currentMode > mode.S && !$button[0]) {
                $button = $sliderItem.parents('.p-category').prev().find('.p-slider-item').last().find('a');

                if (!$button[0]) {
                    $button = $mainClose;
                }
            }

            onPexClick({ currentTarget: $button[0] });
        }

        /**
         * Show the next slider item
         *
         * @method prevSliderItem
         * @access private
         * @param {Event} event
         */
        function nextSliderItem(event) {
            if (event) {
                event.preventDefault();
            }

            var $button = $navSliderItems.find('.p-active').parents('.p-slider-item').next().find('a');

            if (currentMode > mode.S && !$button[0]) {
                $button = $($navSliderItems[currentActive]).find('a');

                if (!$button[0]) {
                    $button = $mainClose;
                }
            }

            onPexClick({ currentTarget: $button[0] });
        }

        /**
         * Change the category and slide to the first item of the category
         *
         * @method changeCategory
         * @access private
         * @param {String} newCategory
         */
        function changeCategory(newCategory) {
            currentCategory = newCategory;

            $mobileCategoryLinks.not('[data-category="' + currentCategory + '"]').removeClass('p-active');
            $mobileCategoryLinks.filter('[data-category="' + currentCategory + '"]').addClass('p-active');

            $component.attr('data-current-category', newCategory);

            setZoomButtons();
        }

        /**
         * Start the 360 view
         *
         * @method start360view
         * @access private
         */
        function start360view() {
            $component.addClass('p-show-360');
            changeCategory('360');
            toggleSmallResetButton();
        }

        /**
         * Reset the 360 view
         *
         * @method reset360view
         * @access private
         */
        function reset360view() {
            $component.removeClass('p-show-360');
            changeCategory('packshot');
        }

        /**
         * Add the "p-loaded-360"  class when the 360 is loaded
         *
         * @method loaded360view
         * @access private
         */
        function loaded360view() {
            $component.addClass('p-loaded-360');
        }

        /**
         * Start the 360 manually
         *
         * @method start360viewManual
         * @access private
         * @param {Event} event
         */
        function start360viewManual(event){
            if (typeof event !== 'undefined') {
                event.preventDefault();
            }
            viewer360Instance.start();
        }

        /**
         * Initialize the 360 library
         *
         * @method init360
         * @access private
         * @param {Event} [event]
         */
        function init360(event) {

            if (typeof event !== 'undefined') {
                event.preventDefault();
            }

            var isHotspots  = ($viewer360Holder.attr('data-hotspot') !== undefined) ? true : false,
                is360       = ($viewer360Holder.attr('data-img') !== undefined) ? true : false;

            if( $viewer360Holder && is360 ){

                $pexLinks.filter('[href="#p-packshot"]').trigger('click');

                if (!$viewer360Holder.data('is360')) {
                    viewer360Instance = viewer360.create($viewer360Holder, {
                        hotspots: isHotspots,
                        debug: true,
                        imageurl: $viewer360Holder.attr('data-img'),
                        hotspotsurl: $viewer360Holder.attr('data-hotspot'),
                        activeAndLoading: true,
                        viewerElement: $viewer360Holder
                    });
                    $viewer360Holder.data('is360', true);
                } else {
                    start360viewManual();
                }

                $viewer360Reset.on('click', reset360);
            }
        }

        /**
         * Hide the 360 button
         *
         * @method hide360Btn
         * @access private
         * @param {Event} event
         */
        function hide360Btn() {
            if ($viewer360Holder.attr('data-img') === undefined) {
                $component.find('.p-360').hide();
            }
        }

        /**
         * Close the 360
         *
         * @method close360
         * @access private
         * @param {Event} event
         */
        function close360(event) {
            if (event) {
                event.preventDefault();
            }

            if ($component.hasClass('p-show-360')) {
                if (viewer360Instance) {
                    viewer360Instance.reset();
                }

                $component.removeClass('p-show-360');
                toggleSmallResetButton();
            }
        }

        /**
         * Reset the 360
         *
         * @method reset360
         * @access private
         */
        function reset360() {
            if (viewer360Instance) {
                viewer360Instance.reset();
            }
        }

        /**
         * Adds click events to all PEX Links (For re-init after Async calls)
         *
         * @method addPexLinks
         * @access private
         */
        function addPexLinks() {
            $pexLinks = $component.find('.p-pex-link');
            $pexLinks.off('.pex-link').on('click.pex-link', onPexClick);

            $('.p-show-360').off('.360-init').on('click.360-init', function(event){
                event.preventDefault();
                if (currentMode <= mode.S) {
                    start360view();
                    init360();
                } else {
                    start360viewManual();
                }
            });
        }

        /**
         * Handles the PEX slider click on an item
         *
         * @method onPexClick
         * @access private
         * @param {Event} event
         */
        function onPexClick(event) {
            if (event && event.preventDefault) {
                event.preventDefault();
            }

            if (tweenEnabled && zoomEnabled) {
                var $btn = $(event.currentTarget),
                    $target = $mainItems.filter('[data-pex-id="' + $btn.attr('href').substr(1) + '"]');

                close360();

                if ($target[0]) {
                    $pexLinks.not('[href="' + $btn.attr('href') + '"]').removeClass('p-active');
                    $pexLinks.filter('[href="' + $btn.attr('href') + '"]').addClass('p-active');

                    var newActive = getMainItemKey($target),
                        newCategory = $target.attr('data-type');

                    onPexZoom(newActive, newCategory);
                    if(newCategory !== "packshot"){
                    	$('html, body').animate({scrollTop : scrollTo}, 700, easing('easeInOutQuad'));
                    }
                }
            }
        }

        /**
         * Handles the pex zoom
         *
         * @method onPexZoom
         * @access private
         * @param {String} newActive
         * @param {String} newCategory
         */
        function onPexZoom(newActive, newCategory) {
            if (newActive === currentActive && zoomLevel !== 0) {
                zoomBack();
            } else if (newActive !== currentActive) {
                changeCategory(newCategory);
                zoomBackPreload(zoomLevel,newActive);
            } else if (currentMode <= mode.S && currentCategory === '360' && newCategory === 'packshot') {
                changeCategory(newCategory);
            }
        }

        /**
         * Zoom back and preload the image
         *
         * @method zoomBackPreload
         * @access private
         * @param {Number} zoomLevel
         * @param {Number} newActive
         */
        function zoomBackPreload(zoomLevel,newActive) {
            if (zoomLevel !== 0) {
                zoomBack(false, $.proxy(preloadSlide, this, newActive));
            } else {
                preloadSlide(newActive);
            }
        }

        /**
         * Preload the Current Slide Before do the Real slide
         *
         * @method preloadSlide
         * @access private
         * @param {Number} newActive
         */
        function preloadSlide(newActive) {
            tweenEnabled = false;

            $($mainItems[newActive]).addClass('p-new-slide');

            if ( $($mainItems[newActive]).find('[data-picture-lazy]:visible')[0] ) {
                picturefillLazy($($mainItems[newActive]), function(){

                    var imageSrc = $($mainItems[newActive]).find('[data-picture-lazy]:visible img').attr('src');

                    if ($.inArray(imageSrc, loadedImages) < 0) {
                        preloadImages([imageSrc], function(){
                            loadedImages.push(imageSrc);
                            slide(newActive);
                        });
                    } else {
                        slide(newActive);
                    }

                });
            } else {
                slide(newActive);
            }
        }

        /**
         * On XS/S the Video's and Images have switched position. Return the new tween Direction
         *
         * @method getSmallTweenDirection
         * @access private
         * @param {Number} newActive
         */
        function getSmallTweenDirection(newActive) {
            var fakeNewActive = newActive,
                newCategory = $( $mainItems[newActive] ).attr('data-type'),
                oldCategory = $( $mainItems[currentActive] ).attr('data-type');

            if (newCategory === 'image' && oldCategory === 'video') {
                fakeNewActive = -1;
            } else if (newCategory === 'video' && oldCategory === 'image') {
                fakeNewActive = $mainItems.length;
            }

            return fakeNewActive;
        }

        /**
         * Default Main Slide Action
         *
         * @method slide
         * @access private
         * @param {Number} newActive
         */
        function slide(newActive) {

            philips.components.atomic.videoV2.pauseInstances();

            var fakeNewActive = currentMode < mode.M ? getSmallTweenDirection(newActive) : newActive,
                from = (fakeNewActive > currentActive ? '100%' : '-100%'),
                toAbs = (fakeNewActive > currentActive ? -$component.width() : $component.width()),
                to = (fakeNewActive > currentActive ? '-100%' : '100%');

            var $oldActive = $($mainItems[currentActive]);

            $oldActive.css({ 'height': $oldActive.height() }).animate({
                'left': toAbs,
                'height': $($mainItems[newActive]).outerHeight()
            }, defaultSlideDuration, easing('easeInOutQuad'), function() {

                $oldActive.css({ 'left': to, 'height': 'auto' });

                $oldActive.removeClass('p-current');
                $($mainItems[newActive]).addClass('p-current');
                setAttrDownloadButton();

            });

            $($mainItems[newActive]).css({ 'left': from }).animate({ 'left': '0' }, defaultSlideDuration, easing('easeInOutQuad'), function(){
                tweenEnabled = true;

                initCurrentSlideVideo();
                initCurrentSlide();

                if(videoRendered) {
                    initCurrentSlideVideo();
                }

                if(galleryRendered) {
                    initCurrentSlide();
                }
            });

            currentActive = newActive;

            $($mainItems[newActive]).removeClass('p-new-slide');
            adjustNavButtonForCaption();
        }
        
        /**
         * Initialize the Current Active Slide
         *
         * @method initCurrentSlide
         * @access private
         */
        function initCurrentSlide() {
            toggleCloseButton();
            toggleSmallResetButton();
            toggleDownloadButton();

            checkSmallSliderNav();
            setSliderNumbers();
            setZoomButtons();
        }

        /**
         * Initialize the video slide
         *
         * @method initCurrentSlideVideo
         * @access private
         */
        function initCurrentSlideVideo() {
            var $li = $($mainItems[currentActive]);
            if( $li.attr('data-type') === 'video' ){
                if (videos[currentActive]) {
                    videos[currentActive].play();
                } else {
                    videos[currentActive] = philips.components.atomic.videoV2.create( $li.find('.p-video') );
                    setTimeout(function(){
                        tracking();
                           },5000);
                }
            }
        }

        /**
         * Toggle visibility of the Small Reset Button
         *
         * @method initCurrentSlideVideo
         * @access private
         */
        function toggleSmallResetButton(){
            if (currentCategory !== 'packshot') {
                $resetSmallButton.addClass('p-show');
            } else {
                $resetSmallButton.removeClass('p-show');
            }
        }

        /**
         * Toggle visibility of the Download Button
         *
         * @method toggleDownloadButton
         * @access private
         */
        function toggleDownloadButton() {
            if (currentCategory === 'image') {
				$smallSliderNumbers.addClass('p-show');
                $downloadImage.addClass('p-show');
                $smallSliderNumbers.find('.p-count').removeClass('p-hidden');
            } else if(  zoomLevel > 0) { 
                $smallSliderNumbers.addClass('p-show');
                $downloadImage.addClass('p-show');
                $smallSliderNumbers.find('.p-count').addClass('p-hidden');
            } else if (currentCategory === 'video') {
                $smallSliderNumbers.addClass('p-show');
                $downloadImage.removeClass('p-show');
                $smallSliderNumbers.find('.p-count').removeClass('p-hidden');
            } else {
                $smallSliderNumbers.removeClass('p-show');
                $downloadImage.removeClass('p-show');
                $smallSliderNumbers.find('.p-count').addClass('p-hidden');
            }
        }

        /**
         * For download button change href, download & title
         * @access private
         */
        function setAttrDownloadButton() {
            var $targetImage;
            if (currentCategory === 'image') {
                $targetImage = $component
                        .find('.p-viewer .p-image-item.p-current');
                $downloadImage.attr({
                    href : $targetImage.find(
                            '.p-product-image.p-zoom-super span').attr(
                            'data-src'),
                    download : $targetImage.attr('data-download-name'),
                    title : $targetImage.attr('data-download-name')
                });
            } else if (currentCategory === 'packshot') {
                $targetImage = $component.find('.p-picture-wrapper');
                $downloadImage.attr({
                    href : $targetImage.find(
                            '.p-product-image.p-zoom-super span').attr(
                            'data-src'),
                    download : $targetImage.attr('data-download-name'),
                    title : $targetImage.attr('data-download-name')
                });
            } else {
                $downloadImage.attr({
                    href : '',
                    download : '',
                    title : ''
                });
            }
        }

        /**
         * Toggle visibility of the Close Button
         *
         * @method toggleDownloadButton
         * @access private
         */
        function toggleCloseButton() {
            if (currentCategory !== 'packshot'
                    || (currentCategory === 'packshot' && zoomLevel !== 0)) {
                $mainClose.addClass('p-show-button');
            } else {
                $mainClose.removeClass('p-show-button');
            }
        }
        /**
         * Set the current numbers of the Small Slider
         *
         * @method setSliderNumbers
         * @access private
         */
        function setSliderNumbers() {
            var totalItems,
                noToLess;            
            if (currentMode < mode.M) {
                noToLess = (currentCategory === 'image') ? getCategoryItemsNum('video') : 0;
                totalItems = getCategoryItemsNum(currentCategory);
                $smallSliderNumbers.find('.p-current-number').text(currentActive - noToLess);
                $smallSliderNumbers.find('.p-total-number').text(totalItems);
            } else {
                totalItems = getCategoryItemsNum('video') + getCategoryItemsNum('image');
                $smallSliderNumbers.find('.p-current-number').text(currentActive);
                $smallSliderNumbers.find('.p-total-number').text(totalItems);
            }
        }

        /**
         * Check whether to show or hide the Small Slider Navigation and Activates the correct buttons
         *
         * @method checkSmallSliderNav
         * @access private
         */
        function checkSmallSliderNav() {
            var show = true,
                $currentItems = getCurrentCategoryItems(),
                currentKey = getMainItemKey($($mainItems[currentActive]), $currentItems);

            if ($currentItems.length < 2 || currentCategory === 'packshot' && currentCategory === '360') {
                show = false;
            }

            if (show === false) {
                $smallSliderNumbers.find('.p-count').addClass('p-hidden');
                $smallSliderNav.removeClass('p-show');
            } else {
                $smallSliderNumbers.find('.p-count').removeClass('p-hidden');
                $smallSliderNav.addClass('p-show');
            }

            if (currentMode < mode.M) {
                if (currentKey === 0) {
                    $smallSliderNavPrev.removeClass('p-active');
                } else {
                    $smallSliderNavPrev.addClass('p-active');
                }
    
                if (currentKey >= $currentItems.length - 1) {
                    $smallSliderNavNext.removeClass('p-active');
                } else {
                    $smallSliderNavNext.addClass('p-active');
                }
            } else {
                var totalItems = getCategoryItemsNum('video') + getCategoryItemsNum('image');

                if (currentActive === 1) { 
                    $smallSliderNavPrev.removeClass('p-active');
                    $smallSliderNavPrev.off('click', prevSliderItem);
                } else {
                    $smallSliderNavPrev.addClass('p-active');
                    $smallSliderNavPrev.on('click', prevSliderItem);
                } 

                if (currentActive === totalItems) {
                    $smallSliderNavNext.removeClass('p-active');
                    $smallSliderNavNext.off('click', nextSliderItem);
                } else {
                    $smallSliderNavNext.addClass('p-active');
                    $smallSliderNavNext.on('click', nextSliderItem);
                }
            }
        }

        function adjustNavButtonForCaption() {
            if($($mainItems[currentActive]).find(".p-caption").length > 0) { 
                var captionHeight = parseInt($($($mainItems[currentActive]).find(".p-caption")).height());
                $smallSliderNavPrev.css("margin-top", 0 - (captionHeight/2));
                $smallSliderNavNext.css("margin-top", 0 - (captionHeight/2));
            }else{
                $smallSliderNavPrev.css("margin-top", "auto");
                $smallSliderNavNext.css("margin-top", "auto");
            }
        }
        /**
         * Find the index of a mainItem
         *
         * @method getMainItemKey
         * @access private
         * @param {Object} $item
         * @param {Array} $haystack
         */
        function getMainItemKey($item, $haystack) {
            var key,
                $items = $haystack || $mainItems;

            $items.each(function(i, elm){
                if ($item[0] === elm){
                    key = i;
                }
            });

            return key;
        }

        /**
         * Retrieve the number of items from the specified category
         *
         * @method getCategoryItemsNum
         * @access private
         * @param {String} category
         * @returns {Number}
         */
        function getCategoryItemsNum(category) {
            return $mainItems.filter('[data-type="' + category + '"]').length;
        }

        /**
         * Retrieve the items from the current category
         *
         * @method getCurrentCategoryItems
         * @access private
         * @returns {Object}
         */
        function getCurrentCategoryItems() {
            return $mainItems.filter('[data-type="' + currentCategory + '"]');
        }

        /**
         * Retrieve the start index position of the current category
         *
         * @method getCurrentCategoryStartIndex
         * @access private
         * @returns {Mixed}
         */
        function getCurrentCategoryStartIndex() {
            var categoryStartIndex = null;

            $mainItems.each(function(i, elm){
                if ($(elm).attr('data-type') === currentCategory && categoryStartIndex === null) {
                    categoryStartIndex = i;
                }
            });

            return categoryStartIndex;
        }

        /**
         * Add Zoom Click events to pictures
         *
         * @method addZoomEvents
         * @access private
         */
        function addZoomEvents() {
            $mainItems.filter('.p-image-item').each(function(){
                var $wrapper = $(this);

                $wrapper.data('normalView', $wrapper.find('.p-normal-view'))
                    .data('firstZoom', $wrapper.find('.p-zoom'))
                    .data('secondZoom', $wrapper.find('.p-zoom-super'));

                $wrapper.off('.pex-zoom').on('click.pex-zoom', function(event){
                    if (!$(event.target).hasClass('p-download-image')) {
                        $curZoomWrapper = $wrapper;
                        zoom();
                    }
                });

                $zoomWrapper.off('.pex-zoom').on('click.pex-zoom', zoom);
            });

            $mainItems.filter('.p-packshot-item').each(function(){
                var $wrapper = $(this);

                $wrapper.data('normalView', $wrapper.find('.p-normal-view'))
                    .data('firstZoom', $wrapper.find('.p-zoom'))
                    .data('secondZoom', $wrapper.find('.p-zoom-super'));
            });
        }

        /**
         * Check the type of the Zoom
         *
         * @method zoom
         * @access private
         */
        function zoom() {
            if (currentMode < mode.M || !zoomEnabled || !tweenEnabled) {
                return false;
            }
            zoomEnabled = false;
            $component.removeClass('p-zoomed-full');
            if (zoomLevel === 2 && currentCategory === 'image' ) {
                $smallSliderNav.addClass('p-show');
                zoomBack();
            } else if (zoomLevel === 2){
                zoomBack();
                $smallSliderNav.removeClass('p-show');
             }else {
                $smallSliderNav.removeClass('p-show');
                zoomInPreload();
            }
        }

        /**
         * Preloads the new Zoom Image
         *
         * @method zoomInPreload
         * @access private
         */
        function zoomInPreload() {

            var $normalView = $curZoomWrapper.data('normalView'),
                $firstZoom = $curZoomWrapper.data('firstZoom'),
                $secondZoom = $curZoomWrapper.data('secondZoom');
            var $newElm = $normalView,
                $curImg = $normalView.find('img');
            $component.find('li.p-image-item .p-caption').hide();
            if (zoomLevel === 0) {
                $newElm = $firstZoom;
                $curImg = $normalView.find('img');
            } else if (zoomLevel === 1) {
                $newElm = $secondZoom;
                $curImg = $firstZoom.find('img');

            }

            $newElm.addClass('p-zoom-show');

            var tempActive = currentActive;

            picturefillLazy($curZoomWrapper, function(){

                var loadSrc = $newElm.find('img').attr('src');

                if ($.inArray(loadSrc, loadedImages) < 0) {
                    preloadImages([$newElm.find('img').attr('src')], function(){
                        loadedImages.push(loadSrc);

                        if (tempActive === currentActive) {
                            if (currentCategory === 'packshot' && zoomLevel === 0) {
                                prepareZoomPackshot(function(){
                                    zoomIn($newElm, $curImg);
                                });
                            } else {
                                zoomIn($newElm, $curImg);
                            }
                        }

                    });
                } else {
                    if (currentCategory === 'packshot' && zoomLevel === 0) {
                        prepareZoomPackshot(function(){
                            zoomIn($newElm, $curImg);
                        });
                    } else {
                        zoomIn($newElm, $curImg);
                    }
                }

            });

        }

        /**
         * Prepare the Packshot for Zooming (Center the Image and FadeOut items)
         *
         * @method prepareZoomPackshot
         * @access private
         */
        function prepareZoomPackshot(callback) {
            if (currentCategory === 'packshot') {
                $zoomWrapper.addClass('p-packshot-zoomed');
                $component.addClass('p-zoom-packshot');
            }

            var fullWidth = $component.width(),
                $infoWrapper = $curZoomWrapper.find('.p-info-wrapper'),
                $packShot = $curZoomWrapper.find('.p-packshot');

            $infoWrapper.animate({ 'left': fullWidth }, 300, easing('easeInOutQuad'));
            $packShot.animate({ 'left': (fullWidth - $packShot.width()) / 2 }, 310, easing('easeInOutQuad'), function(){
                $infoWrapper.css('left', '100%');
                $packShot.css({
                    'margin': '0 auto',
                    'left': 0
                });

                if (callback) {
                    callback();
                }
            });
        }

        /**
         * Prepare the Packshot for Zooming Back Complete (Image to the Left and FadeIn Items)
         *
         * @method prepareZoomCompletePackshot
         * @access private
         */
        function prepareZoomCompletePackshot(callback, disableTween) {

            var fullWidth = $component.width(),
                $packShot = $curZoomWrapper.find('.p-packshot'),
                $infoWrapper = $curZoomWrapper.find('.p-info-wrapper');

            $zoomWrapper.removeClass('p-show');

            if (disableTween) {

                $packShot.removeAttr('style');
                $infoWrapper.removeAttr('style');

                if (currentCategory === 'packshot') {
                    $zoomWrapper.removeClass('p-packshot-zoomed');
                    $component.removeClass('p-zoom-packshot');
                }

                if (callback) {
                    callback();
                }

            } else {
                $infoWrapper.animate({ 'left': ($component.width() / 100) * 50 }, 300, easing('easeInOutQuad'), function(){
                    $infoWrapper.removeAttr('style');
                });
                $packShot.css({
                    'left': (fullWidth - $packShot.width()) / 2,
                    'margin': 0
                }).animate({ 'left': 0 }, 300, easing('easeInOutQuad'), function(){
                        $infoWrapper.removeAttr('style');
                        $curZoomWrapper.find('.p-packshot').removeAttr('style');
                        $curZoomWrapper.find('.p-info-wrapper').removeAttr('style');

                        if (currentCategory === 'packshot') {
                            $zoomWrapper.removeClass('p-packshot-zoomed');
                            $component.removeClass('p-zoom-packshot');
                        }

                        if (callback) {
                            callback();
                        }
                    });
            }
        }

        /**
         * Zooms in to a new Level
         *
         * @method zoomIn
         * @access private
         * @param {Object} $newElm
         * @param {Object} $curImg
         */
        function zoomIn($newElm, $curImg) {
            $zoomWrapper.append($newElm);
            $zoomWrapper.addClass('p-show');

            $newElm.removeClass('p-zoom-show').addClass('p-show');

            var $img = $newElm.find('img'),
                realHeight = $img.height(),
                realWidth = $img.width();

            $img.removeAttr('width').removeAttr('height').css({
                'height': $curImg.height(),
                'marginLeft': philips.isIE8 ? -$curImg.width() / 2 : 0
            });

            if (zoomLevel === 1) {
                $curZoomWrapper.append($curZoomWrapper.data('firstZoom').removeClass('p-show'));
            }

            $img.animate({
                'height': realHeight,
                'marginLeft': philips.isIE8 ? -realWidth / 2 : 'auto'
            }, defaultZoomDuration, easing('easeInOutQuad'), function(){
                zoomEnabled = true;
            });
            $curZoomWrapper.css({
                'height': zoomLevel === 0 ? $curZoomWrapper.height() : $zoomWrapper.height()
            }).animate({
                    'height': realHeight + parseInt($zoomWrapper.css('paddingTop'), 10)
                }, defaultZoomDuration - 25, easing('easeInOutQuad'));

            ++zoomLevel;

            if (zoomLevel === 2) {
                $component.addClass('p-zoomed-full');
            }

            toggleCloseButton();
            toggleDownloadButton();
            setZoomButtons();
        }

        /**
         * Zoom back from current to default view
         *
         * @method zoomBack
         * @access private
         * @param {Bool} disableTween
         */
        function zoomBack(disableTween, callback) {

            var $normalView = $curZoomWrapper.data('normalView'),
                $secondZoom = $zoomWrapper.find('.p-product-image'),
                $img = $secondZoom.find('img'),
                $normalImage = $normalView.find('img');

            var newHeight = $normalImage.height();
            $component.find('li.p-image-item .p-caption').show();
            zoomEnabled = false;

            $img.animate({
                'height': newHeight,
                'marginLeft': philips.isIE8 ? -$normalImage.width() / 2 : 0
            }, disableTween ? 0 : defaultZoomDuration, easing('easeInOutQuad'), function(){

            });

            zoomLevel = 0;

            var extraHeight = 0;
            if (currentCategory === 'packshot') {
                extraHeight = $component.find('.p-packshot-options').outerHeight() + 30;
            }

            var scrollTop = $component.position().top;
            events.scrollTop(scrollTop);

            if (disableTween) {
                $curZoomWrapper.css({
                    'height': 'auto'
                });

                if (currentCategory === 'packshot') {
                    prepareZoomCompletePackshot(function(){
                        zoomBackComplete($img, $secondZoom);
                    }, true);
                } else {
                    zoomBackComplete($img, $secondZoom);
                }
            } else {
                var $zoomWrap = $curZoomWrapper;
                $curZoomWrapper.animate({
                    'height': newHeight + extraHeight
                }, defaultZoomDuration, easing('easeInOutQuad'), function(){

                    $zoomWrap.css({
                        'height': 'auto'
                    });

                    if ($zoomWrap.attr('data-type') === 'packshot') {
                        prepareZoomCompletePackshot(function(){
                            zoomBackComplete($img, $secondZoom);
                        });
                    } else {
                        zoomBackComplete($img, $secondZoom);
                    }

                    if (callback) {
                        callback();
                    }
                });
            }

        }

        /**
         * Zoom back Complete function
         *
         * @method zoomBackComplete
         * @access private
         * @param {Object} $img
         * @param {Object} $secondZoom
         */
        function zoomBackComplete($img, $secondZoom) {
            $img.height('auto');
            $curZoomWrapper.append($secondZoom.removeClass('p-show'));
            $zoomWrapper.removeClass('p-show').removeClass('p-packshot-zoomed');
            $component.removeClass('p-zoom-packshot');

            $curZoomWrapper = null;
            zoomEnabled = true;

            setZoomButtons();
            toggleDownloadButton();
            toggleCloseButton();
        }

        /**
         * Show/Hide the Zoom Buttons
         *
         * @method zoomBackComplete
         * @access private
         */
        function setZoomButtons() {
            if (currentCategory === 'image' || currentCategory === 'packshot') {
                if (zoomLevel < 1) {
                    $component.find('.p-zoom-in').addClass('p-show');
                    $component.find('.p-zoom-out').removeClass('p-show');
                } else {
                    $component.find('.p-zoom-in').removeClass('p-show');
                    $component.find('.p-zoom-out').addClass('p-show');
                }
            } else {
                $component.find('.p-zoom-in').removeClass('p-show');
                $component.find('.p-zoom-out').removeClass('p-show');
            }
        }

        /**
         * Initialize the Small Mode view (Reposition Elements in DOM)
         *
         * @method initSmallMode
         * @access private
         */
        function initSmallMode() {
            if (zoomLevel !== 0) {
                zoomBack(true);
            }
            $component.find('.p-inner-wrapper').prepend($productInfo);
            $component.append($productPriceInfo);
            $rating.prependTo($productPriceInfo);
        }

        /**
         * Initialize the Default Mode view (Reposition Elements in DOM)
         *
         * @method initDefaultMode
         * @access private
         */
        function initDefaultMode() {
            $component.find('.p-info-wrapper').prepend($productInfo);
            $component.find('.p-info-wrapper').append($productPriceInfo);
        }

        /**
         * Resize the fontsize
         *
         * @method resizeFontSize
         * @access private
         * @param {String} toMode @see philips.responsive.mode
         */
        function resizeFontSize(toMode) {
            var $productTitleWrapper = $component.find('.p-heading-product'),
                wrapperHeight = parseInt($productTitleWrapper.css('height'), 10),
                $productTitle = $productTitleWrapper.find('.p-heading-product-title'),
                extraBoldHeight = 3,
                lineHeight = parseInt($productTitle.css('line-height'), 10),
                maxHeight = wrapperHeight > (lineHeight * 3) + extraBoldHeight,
                headingClass = '';

            if(maxHeight) {
                if(toMode === mode.L) {
                    headingClass = 'p-l-heading';
                } else if(toMode === mode.M) {
                    headingClass = 'p-m-heading';
                }

                $productTitle.addClass(headingClass);
            }
        }

  

        // Store the instance in jQuery DOM element for later retrieval.
        $component.data('p18PexArea', instance);

        // Push component to components Array instances list.
        instances.push(instance);

        /**
         * Gets called whenever the responsive mode changes. Use this to make
         * necessary changes to the Object or DOM
         *
         * @todo implement your own functionality
         * @memberOf p18PexAreaInstance
         * @access private
         * @param {Object} e the event
         * @param {String} fromMode @see philips.responsive.mode
         * @param {String} toMode @see philips.responsive.mode
         */
        function handleModeChange(e, fromMode, toMode) {

            currentMode = toMode;

            handleResize();

            if (!fromMode) {
                fromMode = mode.L + 1;
            }

            if (fromMode > mode.S && toMode < mode.M) {
                initSmallMode();
            } else if (fromMode < mode.M && toMode > mode.S) {
                initDefaultMode();
            }

            $component.find('.p-heading-product-title').removeClass('p-l-heading p-m-heading');
            resizeFontSize(toMode);
        }

        /**
         * Tracking is used to track user interaction, add your custom code
         * to track the different user interactions.
         *
         * @todo Implement your own functionality here.
         * @member {Function} tracking
         * @memberOf p18PexAreaInstance
         * @access private
         */
        function tracking() {
            if (typeof document.getElementsByTagName("video")[0] !== "undefined" && typeof s !== "undefined") {
                _page.metrics.trackHTML5Video();
            }
        }

        /**
         * Public example method, you can use this for instance to re-render
         * the component
         *
         * @todo implement your own functionality here
         * @member {Function} render
         * @memberOf p18PexAreaInstance
         * @access public
         * @returns {Mixed}
         */
        function render() {
            setElements();
            addPexLinks();
            addZoomEvents();
            initCurrentSlide();
            galleryRendered = true;
        }

        /**
         * Public example method, you can use this for instance to re-render the video atomic
         * the component
         *
         * @todo implement your own functionality here
         * @member {Function} render
         * @memberOf p18PexAreaInstance
         * @access public
         * @returns {Mixed}
         */
        function renderVideo() {
            initCurrentSlideVideo();
            videoRendered = true;
        }

        // Returns the instance.
        return instance;
    }

    // Return the namespace.
    return {
        toString: function(){return '[object P_18v2 Pex Area]';},
        instances: instances,
        create: create
        // Expose other component methods and/or variables.
    };
})(jQuery);

window.philips = window.philips || {};

